/**
 * Lo-Fi Streetwear — Shopify 2.0 Theme JS
 * Single entry-point loaded with defer="defer".
 */

(function () {
  'use strict';

  /* ------------------------------------------------------------------ */
  /*  Utilities                                                          */
  /* ------------------------------------------------------------------ */

  function debounce(fn, wait) {
    var timer;
    return function () {
      var context = this;
      var args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(context, args);
      }, wait);
    };
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    var fmt = format || window.theme.moneyFormat;
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = placeholderRegex.exec(fmt);
    if (!match) return fmt;

    var placeholder = match[1];
    switch (placeholder) {
      case 'amount':
        value = (cents / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
        break;
      case 'amount_no_decimals':
        value = Math.round(cents / 100)
          .toString()
          .replace(/(\d)(?=(\d{3})+$)/g, '$1,');
        break;
      case 'amount_with_comma_separator':
        value = (cents / 100)
          .toFixed(2)
          .replace(/\./, ',')
          .replace(/(\d)(?=(\d{3})+,)/g, '$1.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = Math.round(cents / 100)
          .toString()
          .replace(/(\d)(?=(\d{3})+$)/g, '$1.');
        break;
      case 'amount_with_apostrophe_separator':
        value = (cents / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1'");
        break;
      case 'amount_no_decimals_with_space_separator':
        value = Math.round(cents / 100)
          .toString()
          .replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
        break;
      case 'amount_with_space_separator':
        value = (cents / 100)
          .toFixed(2)
          .replace(/\./, ',')
          .replace(/(\d)(?=(\d{3})+,)/g, '$1 ');
        break;
      default:
        value = (cents / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
    }

    return fmt.replace(placeholderRegex, value);
  }

  var HEADERS = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  };

  function fetchCart() {
    return fetch(window.theme.routes.cart_url + '.js', {
      headers: { Accept: 'application/json' },
    }).then(function (r) {
      return r.json();
    });
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function updateCartDrawer() {
    var u = window.location.href;
    u += (u.indexOf('?') === -1 ? '?' : '&') + '_cd=' + Date.now(); // cache-buster: force a fresh cart render
    return fetch(u, {
      headers: { Accept: 'text/html' },
      cache: 'no-store',
    })
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var freshDrawer = doc.querySelector('[data-cart-drawer]');
        var currentDrawer = document.querySelector('[data-cart-drawer]');
        if (freshDrawer && currentDrawer) {
          currentDrawer.innerHTML = freshDrawer.innerHTML;
        }
        // Also update cart count from the fresh markup
        var freshCount = doc.querySelector('[data-cart-count]');
        if (freshCount) {
          updateCartCount(freshCount.textContent.trim());
        }
      });
  }

  function lockScroll() {
    document.body.style.overflow = 'hidden';
  }

  function unlockScroll() {
    document.body.style.overflow = '';
  }

  function showOverlay() {
    var overlay = document.querySelector('.overlay');
    if (overlay) overlay.classList.add('overlay--active');
  }

  function hideOverlay() {
    var overlay = document.querySelector('.overlay');
    if (overlay) overlay.classList.remove('overlay--active');
  }

  function trapFocus(container) {
    var focusable = container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (!focusable.length) return null;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    function handler(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }
    container.addEventListener('keydown', handler);
    first.focus();
    return function removeTrap() {
      container.removeEventListener('keydown', handler);
    };
  }

  /* ------------------------------------------------------------------ */
  /*  State                                                              */
  /* ------------------------------------------------------------------ */

  var removeFocusTrap = null;

  /* ------------------------------------------------------------------ */
  /*  1. Mobile Menu                                                     */
  /* ------------------------------------------------------------------ */

  function initMobileMenu() {
    var menu = document.querySelector('.mobile-menu');
    if (!menu) return;

    function open() {
      menu.classList.add('mobile-menu--active');
      showOverlay();
      lockScroll();
      var toggle = document.querySelector('[data-mobile-menu-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      removeFocusTrap = trapFocus(menu);
    }

    function close() {
      menu.classList.remove('mobile-menu--active');
      hideOverlay();
      unlockScroll();
      var toggle = document.querySelector('[data-mobile-menu-toggle]');
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      }
      if (removeFocusTrap) {
        removeFocusTrap();
        removeFocusTrap = null;
      }
    }

    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-mobile-menu-toggle]');
      if (openBtn) {
        e.preventDefault();
        menu.classList.contains('mobile-menu--active') ? close() : open();
        return;
      }

      var closeBtn = e.target.closest('[data-mobile-menu-close]');
      if (closeBtn) {
        e.preventDefault();
        close();
        return;
      }

      var submenuToggle = e.target.closest('[data-mobile-submenu-toggle]');
      if (submenuToggle) {
        e.preventDefault();
        var parent = submenuToggle.parentElement;
        var submenu = parent ? parent.querySelector('.mobile-nav__submenu') : null;
        if (submenu) {
          var expanded = submenuToggle.getAttribute('aria-expanded') === 'true';
          submenuToggle.setAttribute('aria-expanded', String(!expanded));
          submenu.classList.toggle('mobile-nav__submenu--active');
        }
      }
    });

    // Close on overlay click
    var overlay = document.querySelector('.overlay');
    if (overlay) {
      overlay.addEventListener('click', function () {
        if (menu.classList.contains('mobile-menu--active')) close();
        closeCartDrawer();
      });
    }
  }

  /* ------------------------------------------------------------------ */
  /*  2. Cart Drawer (AJAX)                                              */
  /* ------------------------------------------------------------------ */

  var cartDrawerFocusTrap = null;

  function openCartDrawer() {
    var drawer = document.querySelector('.cart-drawer');
    if (!drawer) return;
    drawer.classList.add('cart-drawer--active');
    document.body.classList.add('cart-open');
    showOverlay();
    lockScroll();
    cartDrawerFocusTrap = trapFocus(drawer);
  }

  function closeCartDrawer() {
    var drawer = document.querySelector('.cart-drawer');
    if (!drawer) return;
    drawer.classList.remove('cart-drawer--active');
    document.body.classList.remove('cart-open');
    hideOverlay();
    unlockScroll();
    if (cartDrawerFocusTrap) {
      cartDrawerFocusTrap();
      cartDrawerFocusTrap = null;
    }
  }

  function handleAddToCart(form, isQuickAdd) {
    var submitBtn = form.querySelector('button[type="submit"], [type="submit"]');
    if (!submitBtn) return;

    var originalText = submitBtn.textContent;
    submitBtn.textContent = 'Adding...';
    submitBtn.disabled = true;

    var formData = new FormData(form);
    var body = {};
    formData.forEach(function (val, key) {
      // app-injected line-item properties (e.g. Customizery griptape selects)
      var pm = key.match(/^properties\[(.+)\]$/);
      if (pm) {
        body.properties = body.properties || {};
        body.properties[pm[1]] = val;
        return;
      }
      body[key] = val;
    });

    // Ensure quantity is a number
    if (body.quantity) body.quantity = parseInt(body.quantity, 10) || 1;
    if (window.theme.setFormError) { window.theme.setFormError(''); }

    fetch(window.theme.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: HEADERS,
      body: JSON.stringify(body),
    })
      .then(function (r) {
        if (!r.ok) {
          // Shopify's 422 body says WHY (usually stock): surface it
          return r.json().catch(function () { return {}; }).then(function (body) {
            var err = new Error('Add to cart failed');
            err.cartMessage = body.description || body.message || '';
            throw err;
          });
        }
        return r.json();
      })
      .then(function () {
        submitBtn.textContent = 'Added To Cart';
        if (!isQuickAdd) {
          submitBtn.classList.add('main-product__add-to-cart--added');
        }

        return fetchCart();
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        return updateCartDrawer();
      })
      .then(function () {
        openCartDrawer();

        setTimeout(function () {
          submitBtn.textContent = originalText;
          submitBtn.disabled = false;
          if (!isQuickAdd) {
            submitBtn.classList.remove('main-product__add-to-cart--added');
          }
        }, 2000);
      })
      .catch(function (err) {
        console.error('Add to cart error:', err);
        submitBtn.textContent = originalText;
        submitBtn.disabled = false;
        if (window.theme.setFormError) {
          var msg = err && err.cartMessage ? err.cartMessage : "Couldn't add to cart — please try again.";
          if (/availab|stock|in your cart/i.test(msg)) { msg = 'Not enough stock — ' + msg.charAt(0).toLowerCase() + msg.slice(1); }
          window.theme.setFormError(msg);
        }
      });
  }

  // Force the drawer's per-line qty, line totals, subtotal/total + count to match
  // the authoritative cart object (the dev server's section render can lag a step).
  function syncDrawerFromCart(cart) {
    reconcileCompanions(cart);
    if (!cart || !cart.items) { return; }
    var fmt = window.theme.formatMoney;
    cart.items.forEach(function (it, i) {
      var line = i + 1;
      var qd = document.querySelector('[data-cart-quantity-input][data-line="' + line + '"]');
      if (qd) {
        if (qd.tagName === 'INPUT') { qd.value = it.quantity; } else { qd.textContent = it.quantity; }
        var item = qd.closest('[data-cart-item]');
        var pr = item && item.querySelector('.cart-drawer__item-price');
        if (pr && fmt) { pr.innerHTML = fmt(it.final_line_price); }
      }
    });
    var sub = document.querySelector('[data-cart-subtotal]');
    if (sub && fmt) { sub.innerHTML = fmt(cart.total_price); }
    var tot = document.querySelector('[data-cart-total]');
    if (tot && fmt) { tot.innerHTML = fmt(cart.total_price); }
    var dc = document.querySelector('[data-cart-drawer-count]');
    if (dc) { dc.textContent = cart.item_count; }
  }

  function handleCartQuantityChange(line, quantity) {
    // Companion add-ons (bundled griptape) are LOCKED to their parent deck.
    // Capture the companions' keys BEFORE the parent changes (removal loses
    // the parent), change the parent, then bring the companions to the same
    // quantity. Sequential — parallel cart calls hit Shopify's cart lock.
    fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var parent = cart.items[line - 1];
        var group = parent && parent.properties && parent.properties._io_order_group;
        var keys = [];
        if (group) {
          cart.items.forEach(function (it) {
            if (it.properties && it.properties._io_parent_order_group === group) { keys.push(it.key); }
          });
        }
        return { group: group, keys: keys };
      })
      .catch(function () { return { keys: [] }; })
      .then(function (lock) { changeParent(line, quantity, lock); });
  }

  // /cart/update.js matches same-variant lines by variant, not by line key —
  // two "Free Grip" lines (same variant, different parent decks) get wiped
  // together when zeroing one. /cart/change.js with the full line key is
  // precise. Sequential — parallel cart calls hit Shopify's cart lock.
  function changeLinesByKey(updates) {
    return Object.keys(updates).reduce(function (p, key) {
      return p.then(function () {
        return fetch(window.theme.routes.cart_change_url + '.js', {
          method: 'POST',
          headers: HEADERS,
          body: JSON.stringify({ id: key, quantity: updates[key] }),
        });
      });
    }, Promise.resolve());
  }

  // Cart janitor: companions must mirror their parent exactly — one grip
  // line per deck line, same quantity. Orphans (parent gone) are removed,
  // over-counts clamp to the parent's qty. Runs on every drawer sync.
  var reconcilingCompanions = false;
  function reconcileCompanions(cart) {
    if (reconcilingCompanions || !cart || !cart.items) { return; }
    var parentQty = {};
    cart.items.forEach(function (it) {
      var g = it.properties && it.properties._io_order_group;
      if (g) { parentQty[g] = (parentQty[g] || 0) + it.quantity; }
    });
    var updates = {};
    var seenGroups = {};
    cart.items.forEach(function (it) {
      var pg = it.properties && it.properties._io_parent_order_group;
      if (!pg) { return; }
      var target = parentQty[pg] || 0;
      if (seenGroups[pg]) { target = 0; } // duplicate companion lines for one deck
      seenGroups[pg] = true;
      if (it.quantity !== target) { updates[it.key] = target; }
    });
    if (!Object.keys(updates).length) { return; }
    reconcilingCompanions = true;
    changeLinesByKey(updates)
      .then(function () { return fetch('/cart.js', { cache: 'no-store' }); })
      .then(function (r) { return r.json(); })
      .then(function (fresh) {
        updateCartCount(fresh.item_count);
        return updateCartDrawer().then(function () {
          reconcilingCompanions = false;
          syncDrawerFromCart(fresh);
        });
      })
      .catch(function () { reconcilingCompanions = false; });
  }

  function syncCompanions(lock) {
    if (!lock || !lock.keys || !lock.keys.length) { return Promise.resolve(); }
    // match the parent's REAL post-change quantity (inventory may have capped
    // the request — e.g. only 1 deck in stock)
    return fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var parent = null;
        cart.items.forEach(function (it) {
          if (it.properties && it.properties._io_order_group === lock.group) { parent = it; }
        });
        var target = parent ? parent.quantity : 0;
        var updates = {};
        var dirty = false;
        cart.items.forEach(function (it) {
          if (lock.keys.indexOf(it.key) > -1 && it.quantity !== target) {
            updates[it.key] = target;
            dirty = true;
          }
        });
        if (!dirty && target === 0) {
          // companions may already be gone — nothing to do
          lock.keys.forEach(function (k) {
            if (cart.items.some(function (it) { return it.key === k; })) { updates[k] = 0; dirty = true; }
          });
        }
        if (!dirty) { return null; }
        return changeLinesByKey(updates).then(function () {
          return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); })
            .then(function (fresh) {
              updateCartCount(fresh.item_count);
              return updateCartDrawer().then(function () { syncDrawerFromCart(fresh); });
            });
        });
      })
      .catch(function () {});
  }

  function changeParent(line, quantity, lock) {
    fetch(window.theme.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: HEADERS,
      body: JSON.stringify({ line: line, quantity: quantity, sections: 'cart-drawer' }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        // re-render the drawer structure (handles removal, the shipping bar)
        if (cart.sections && cart.sections['cart-drawer']) {
          var doc = new DOMParser().parseFromString(cart.sections['cart-drawer'], 'text/html');
          var fresh = doc.querySelector('[data-cart-drawer]');
          var current = document.querySelector('[data-cart-drawer]');
          if (fresh && current) { current.innerHTML = fresh.innerHTML; }
        } else {
          return updateCartDrawer();
        }
      })
      .then(function () {
        // pull the authoritative cart + sync the values (dev server's change/section
        // render can lag a step; /cart.js is always fresh)
        return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); })
          .then(function (fresh) { updateCartCount(fresh.item_count); syncDrawerFromCart(fresh); });
      })
      .then(function () { return syncCompanions(lock); })
      .catch(function (err) {
        console.error('Cart update error:', err);
      });
  }

  function initCartDrawer() {
    document.addEventListener('click', function (e) {
      // Open cart drawer
      var toggle = e.target.closest('[data-cart-toggle]');
      if (toggle) {
        e.preventDefault();
        openCartDrawer();
        return;
      }

      // Close cart drawer
      var closeBtn = e.target.closest('[data-cart-close]');
      if (closeBtn) {
        e.preventDefault();
        closeCartDrawer();
        return;
      }

      // Remove cart item — removes ALL quantity of that line (qty 0)
      var removeBtn = e.target.closest('[data-cart-remove]');
      if (removeBtn) {
        e.preventDefault();
        var removeLine = parseInt(removeBtn.getAttribute('data-line'), 10);
        handleCartQuantityChange(removeLine, 0);
        return;
      }

      // Quantity minus
      var minusBtn = e.target.closest('[data-cart-quantity-minus]');
      if (minusBtn) {
        e.preventDefault();
        var minusLine = parseInt(minusBtn.getAttribute('data-line'), 10);
        var minusVal = minusBtn.parentElement.querySelector('[data-cart-quantity-input]');
        var currentQty = minusVal ? parseInt(minusVal.value || minusVal.textContent, 10) : 1;
        if (currentQty > 1) {
          handleCartQuantityChange(minusLine, currentQty - 1);
        }
        return;
      }

      // Quantity plus
      var plusBtn = e.target.closest('[data-cart-quantity-plus]');
      if (plusBtn) {
        e.preventDefault();
        var plusLine = parseInt(plusBtn.getAttribute('data-line'), 10);
        var plusVal = plusBtn.parentElement.querySelector('[data-cart-quantity-input]');
        var currentPlusQty = plusVal ? parseInt(plusVal.value || plusVal.textContent, 10) : 1;
        handleCartQuantityChange(plusLine, currentPlusQty + 1);
        return;
      }
    });

    // Product form submit
    document.addEventListener('submit', function (e) {
      var productForm = e.target.closest('[data-product-form]');
      if (productForm) {
        e.preventDefault();
        handleAddToCart(productForm, false);
        return;
      }

      var quickAddForm = e.target.closest('[data-quick-add]');
      if (quickAddForm) {
        e.preventDefault();
        handleAddToCart(quickAddForm, true);
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /*  3. Search Overlay (Predictive Search)                              */
  /* ------------------------------------------------------------------ */

  // Search results page: infinite scroll — same behavior as the collection
  // pages: a visible .infinite-scroll-trigger (looping ASCII loader) fetches
  // the next paginated page when it nears the viewport, appends its grid
  // items, and removes itself when no next page remains. The numbered
  // pagination stays in the source for crawlers (html.js hides it).
  function initSearchInfiniteScroll() {
    var grid = document.querySelector('.main-search .product-grid');
    var trigger = document.querySelector('.main-search .infinite-scroll-trigger');
    if (!grid || !trigger || !window.IntersectionObserver) { return; }

    // Global full-price-before-sale ordering across pages: a marker sits
    // where the sale block begins; appended full-price items insert above
    // it, appended sale items go to the bottom — so a later page's new
    // full-price stock can never land below an earlier page's sale items.
    var saleMarker = document.createComment('sale-block');
    var firstSale = null;
    grid.querySelectorAll('.product-grid__item').forEach(function (item) {
      if (!firstSale && item.querySelector('.product-card--on-sale')) { firstSale = item; }
    });
    grid.insertBefore(saleMarker, firstSale);

    var loading = false;
    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting && !loading) {
        loading = true;
        loadNext();
      }
    }, { rootMargin: '200px' });
    io.observe(trigger);

    function loadNext() {
      var url = trigger.getAttribute('data-next-url');
      if (!url) { io.disconnect(); trigger.remove(); return; }
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          doc.querySelectorAll('.main-search .product-grid > *').forEach(function (item) {
            if (item.querySelector && item.querySelector('.product-card--on-sale')) {
              grid.appendChild(item);
            } else {
              grid.insertBefore(item, saleMarker);
            }
          });
          document.dispatchEvent(new CustomEvent('theme:cards-added', { detail: { root: grid } }));
          var newTrigger = doc.querySelector('.main-search .infinite-scroll-trigger');
          if (newTrigger) {
            trigger.setAttribute('data-next-url', newTrigger.getAttribute('data-next-url'));
            loading = false;
          } else {
            io.disconnect();
            trigger.remove();
          }
        })
        .catch(function () {
          io.disconnect();
          trigger.remove();
        });
    }
  }

  // Full-page searches mirror the preview's matching: titles + vendors only,
  // each word as a prefix — '(title:crew* OR vendor:crew*)'. A bare q also
  // matches descriptions/tags, which buries e.g. crewnecks under 800 socks.
  function scopedSearchQuery(q) {
    var toks = q.trim().replace(/[*():"']/g, '').split(/\s+/).filter(Boolean);
    if (!toks.length) { return q; }
    return toks.map(function (t) {
      return '(title:' + t + '* OR vendor:' + t + '*)';
    }).join(' ');
  }

  function initSearch() {
    var searchOverlay = document.querySelector('.search-overlay');
    if (!searchOverlay) return;

    var searchForm = searchOverlay.querySelector('.search-form');
    if (searchForm) {
      searchForm.addEventListener('submit', function (e) {
        // navigate with the scoped query ourselves so the visible input
        // never flashes the raw '(title:… OR vendor:…)' syntax
        var input = searchForm.querySelector('[data-search-input]');
        if (!input || !input.value.trim()) { return; }
        e.preventDefault();
        window.location.assign(
          searchForm.action + '?type=product&q=' + encodeURIComponent(scopedSearchQuery(input.value))
        );
      });
    }

    var searchFocusTrap = null;

    function openSearch() {
      // extend the panel's left edge to the start of the desktop nav buttons
      var nav = document.querySelector('.site-header__nav');
      if (nav && nav.offsetParent !== null) {
        searchOverlay.style.left = Math.round(nav.getBoundingClientRect().left) + 'px';
        searchOverlay.style.width = 'auto';
      } else {
        searchOverlay.style.left = '';
        searchOverlay.style.width = '';
      }
      searchOverlay.classList.add('search-overlay--active');
      // lets CSS drop the body-level ASCII logo (z 160) behind the search on
      // mobile — the logo lives outside the sticky header group, so its own
      // z-index otherwise paints it over the (nested) search overlay
      document.documentElement.classList.add('search-active');
      searchOpenedAt = Date.now();
      lockScroll();
      searchFocusTrap = trapFocus(searchOverlay);
      var input = searchOverlay.querySelector('[data-search-input]');
      if (input) {
        setTimeout(function () {
          input.focus();
        }, 50);
      }
    }

    function closeSearch() {
      searchOverlay.classList.remove('search-overlay--active');
      document.documentElement.classList.remove('search-active');
      unlockScroll();
      if (searchFocusTrap) {
        searchFocusTrap();
        searchFocusTrap = null;
      }
    }
    var searchOpenedAt = 0;

    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-search-toggle]');
      if (openBtn) {
        e.preventDefault();
        openSearch();
        return;
      }

      var closeBtn = e.target.closest('[data-search-close]');
      if (closeBtn) {
        e.preventDefault();
        closeSearch();
        return;
      }

      // Click outside the panel closes it — but ignore stray clicks in the
      // first moment after opening (a synthesized/second event from the same
      // open gesture was reported to auto-collapse it before typing)
      if (
        searchOverlay.classList.contains('search-overlay--active') &&
        !e.target.closest('.search-overlay') &&
        Date.now() - searchOpenedAt > 350
      ) {
        closeSearch();
      }
    });

    // Escape closes the search overlay
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && searchOverlay.classList.contains('search-overlay--active')) {
        closeSearch();
      }
    });

    var resultsContainer = searchOverlay.querySelector('.search-results');

    // ---- instant local brand/category suggestions ----------------------
    // The header ships a JSON index of every non-empty collection
    // ([data-collection-index]); suggestions match client-side per
    // keystroke — no network wait, typo-tolerant (Damerau distance), with
    // a synonym map for category words ("jumper" → hoods/crews/knits).
    var collectionIndex = null;
    function getCollectionIndex() {
      if (collectionIndex) { return collectionIndex; }
      var el = document.querySelector('[data-collection-index]');
      try { collectionIndex = JSON.parse(el.textContent); } catch (e) { collectionIndex = []; }
      return collectionIndex;
    }
    function normStr(str) { return (str || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); }
    function squash(str) { return normStr(str).replace(/ /g, ''); }
    // edit distance with transpositions counted as one op ("obly"→"only")
    function editDist(a, b, max) {
      if (Math.abs(a.length - b.length) > max) { return max + 1; }
      var prev2 = null;
      var prev = [];
      for (var j = 0; j <= b.length; j++) { prev[j] = j; }
      for (var i = 1; i <= a.length; i++) {
        var cur = [i];
        var rowMin = i;
        for (var k = 1; k <= b.length; k++) {
          var cost = a[i - 1] === b[k - 1] ? 0 : 1;
          var v = Math.min(prev[k] + 1, cur[k - 1] + 1, prev[k - 1] + cost);
          if (prev2 && i > 1 && k > 1 && a[i - 1] === b[k - 2] && a[i - 2] === b[k - 1]) {
            v = Math.min(v, prev2[k - 2] + 1);
          }
          cur[k] = v;
          if (v < rowMin) { rowMin = v; }
        }
        if (rowMin > max) { return max + 1; }
        prev2 = prev;
        prev = cur;
      }
      return prev[b.length];
    }
    function scoreCollection(title, query) {
      var t = normStr(title), n = normStr(query);
      if (!n) { return -1; }
      var ts = squash(title), qs = squash(query);
      if (t === n || ts === qs) { return 0; }
      if (t.indexOf(n) === 0 || ts.indexOf(qs) === 0) { return 1; }
      if (t.indexOf(' ' + n) > -1) { return 2; }
      if (t.indexOf(n) > -1 || ts.indexOf(qs) > -1) { return 3; }
      var maxD = qs.length >= 8 ? 2 : qs.length >= 4 ? 1 : 0;
      if (maxD) {
        if (editDist(ts, qs, maxD) <= maxD) { return 4; }
        // typo while still typing: compare against the title's prefix
        if (ts.length > qs.length && editDist(ts.slice(0, qs.length), qs, maxD) <= maxD) { return 5; }
      }
      return -1;
    }
    var SEARCH_SYNONYMS = {
      jumper: ['pullover hood', 'crewneck', 'knit', 'fleece'],
      jumpers: ['pullover hood', 'crewneck', 'knit', 'fleece'],
      sweater: ['crewneck', 'knit', 'pullover hood'],
      sweatshirt: ['crewneck', 'pullover hood'],
      pullover: ['pullover hood', 'crewneck', 'fleece'],
      hoodie: ['pullover hood', 'zip-thru hood'],
      hoodies: ['pullover hood', 'zip-thru hood'],
      hood: ['pullover hood', 'zip-thru hood'],
      sneakers: ['footwear'], sneaker: ['footwear'],
      shoes: ['footwear'], shoe: ['footwear'], trainers: ['footwear'], runners: ['footwear'],
      cap: ['hats'], caps: ['hats'], snapback: ['hats'], bucket: ['hats'],
      skateboard: ['decks'], skateboards: ['decks'], board: ['decks'], boards: ['decks'],
      trousers: ['pants'], jeans: ['denim'],
      tshirt: ['t-shirts'], tshirts: ['t-shirts'], tee: ['t-shirts'], tees: ['t-shirts'],
      mag: ['publications'], mags: ['publications'], magazine: ['publications'],
      book: ['publications'], books: ['publications'], zine: ['publications']
    };
    function matchSuggestions(query) {
      var idx = getCollectionIndex();
      var scored = [];
      idx.forEach(function (c) {
        var sc = scoreCollection(c.t, query);
        if (sc > -1) { scored.push({ c: c, s: sc }); }
      });
      scored.sort(function (a, b) { return a.s - b.s || b.c.n - a.c.n; });
      var brands = [], cats = [];
      scored.forEach(function (w) { (w.c.b ? brands : cats).push(w.c); });

      // synonym expansion → real collections when they exist, else a
      // scoped-search link for the term
      var seen = {};
      cats.forEach(function (c) { seen[squash(c.t)] = true; });
      brands.forEach(function (c) { seen[squash(c.t)] = true; });
      (SEARCH_SYNONYMS[squash(query)] || []).forEach(function (term) {
        var hit = null;
        idx.forEach(function (c) {
          if (hit || c.b) { return; }
          var t = normStr(c.t);
          if (t === term || t.indexOf(term) > -1) { hit = c; }
        });
        if (hit) {
          if (!seen[squash(hit.t)]) { cats.push(hit); seen[squash(hit.t)] = true; }
        } else if (!seen[squash(term)]) {
          var label = term.replace(/(^|\s|-)\w/g, function (m) { return m.toUpperCase(); });
          cats.push({ t: label, u: window.theme.routes.search_url + '?type=product&q=' + encodeURIComponent(scopedSearchQuery(term)) });
          seen[squash(term)] = true;
        }
      });
      return { brands: brands.slice(0, 5), cats: cats.slice(0, 5) };
    }
    function collSectionHtml(label, cols) {
      if (!cols.length) { return ''; }
      var html = '<div class="search-results__section">';
      html += '<h4 class="search-results__heading">' + label + '</h4>';
      html += '<ul class="search-results__brands">';
      cols.forEach(function (c) {
        html += '<li><a href="' + c.u + '" class="search-results__brand-link">' + c.t + ' &#8599;</a></li>';
      });
      return html + '</ul></div>';
    }

    var previewSeq = 0;
    var fetchPreviewProducts = debounce(function (query) {
      var prodUrl =
        window.theme.routes.search_url +
        '?view=preview&type=product&q=' + encodeURIComponent(scopedSearchQuery(query));
      var seq = previewSeq;
      fetch(prodUrl)
        .then(function (r) { return r.text(); })
        .then(function (rows) {
          if (seq !== previewSeq || !resultsContainer) { return; }
          var box = resultsContainer.querySelector('[data-sugg-products]');
          if (!box) { return; }
          rows = (rows || '').trim();
          var html = '';
          if (rows.indexOf('search-results__product') > -1) {
            html += '<div class="search-results__section">';
            html += '<h4 class="search-results__heading">Products:</h4>';
            html += '<div class="search-results__grid">' + rows + '</div></div>';
            html +=
              '<div class="search-results__footer"><a href="' +
              window.theme.routes.search_url + '?type=product&q=' + encodeURIComponent(scopedSearchQuery(query)) +
              '" class="search-results__view-all">View All Results</a></div>';
          } else if (!resultsContainer.querySelector('.search-results__brand-link')) {
            html = '<p class="search-results__empty">No results found.</p>';
          }
          if (window.theme.toggleSearchLoader) { window.theme.toggleSearchLoader(false); }
          box.innerHTML = html;
        })
        .catch(function () {
          if (window.theme.toggleSearchLoader) { window.theme.toggleSearchLoader(false); }
        });
    }, 250);

    var handleSearchInput = function (e) {
      var query = e.target.value.trim();
      previewSeq++;
      if (!resultsContainer) { return; }
      if (!query) {
        resultsContainer.innerHTML = '';
        if (window.theme.toggleSearchLoader) { window.theme.toggleSearchLoader(false); }
        return;
      }
      // suggestions render INSTANTLY from the local index; product rows
      // (server-rendered, single source with the results page) fill in after
      var m = matchSuggestions(query);
      resultsContainer.innerHTML =
        collSectionHtml('Brands:', m.brands) +
        collSectionHtml('Collections:', m.cats) +
        '<div data-sugg-products></div>';
      if (window.theme.toggleSearchLoader) { window.theme.toggleSearchLoader(true); }
      fetchPreviewProducts(query);
    };

    var searchInput = searchOverlay.querySelector('[data-search-input]');
    var searchLoader = searchOverlay.querySelector('[data-search-loading]');
    function toggleSearchLoader(show) {
      if (!searchLoader) return;
      searchLoader.hidden = !show;
      if (show) {
        // the loader initialised while hidden (0-size) — re-measure its canvas
        var el = searchLoader.querySelector('[data-ascii-logo]');
        var inst = el && el.__asciiLogo;
        if (inst && typeof inst._resize === 'function') { inst._resize(); }
      }
    }
    window.theme = window.theme || {};
    window.theme.toggleSearchLoader = toggleSearchLoader;
    if (searchInput) {
      // loader appears only when a fetch is in flight (see handleSearchInput);
      // emptying the field clears everything
      searchInput.addEventListener('input', function (e) {
        if (!e.target.value.trim()) {
          if (resultsContainer) resultsContainer.innerHTML = '';
          toggleSearchLoader(false);
        }
      });
      searchInput.addEventListener('input', handleSearchInput);
    }
  }

  /* ------------------------------------------------------------------ */
  /*  4. Filter Panel                                                    */
  /* ------------------------------------------------------------------ */

  function initFilters() {
    var panel = document.querySelector('[data-filter-panel]');
    var overlay = document.querySelector('[data-filter-overlay]');
    if (!panel) return;

    var mq = window.matchMedia('(max-width: 749px)');
    function togglePanel(open) {
      var isOpen = typeof open === 'boolean' ? open : !panel.classList.contains('filter-panel--active');
      panel.classList.toggle('filter-panel--active', isOpen);
      if (overlay) overlay.classList.toggle('filter-panel__overlay--active', isOpen);
      var toggle = document.querySelector('[data-filter-toggle]');
      if (toggle) {
        toggle.setAttribute('aria-expanded', isOpen);
      }
      // Pin the panel so it reaches the bottom of the viewport (100vh includes the
      // mobile address bar and would overshoot). Mobile = full screen; desktop =
      // from the dropdown position down to just above the bottom. Re-fit every
      // frame while open — scrolling moves the (in-flow) FILTER button, and the
      // panel must always run to the bottom of the screen.
      if (isOpen) { fitPanelHeight(); startFitLoop(); }
      else { panel.style.height = ''; panel.style.maxHeight = ''; lastFitH = ''; }
    }
    var fitRaf = null, lastFitH = '';
    function startFitLoop() {
      if (fitRaf) { return; }
      (function loop() {
        if (!panel.classList.contains('filter-panel--active')) { fitRaf = null; return; }
        fitPanelHeight();
        fitRaf = requestAnimationFrame(loop);
      })();
    }
    function fitPanelHeight() {
      // both breakpoints: from the dropdown (the wrap's bottom) down to the
      // bottom of the viewport, so the Reset/Apply row is pinned to the screen
      // edge. Measure the wrap (untransformed) rather than the mid-transition
      // panel.
      var op = panel.offsetParent || panel.parentElement;
      var topPx = op ? op.getBoundingClientRect().bottom : panel.getBoundingClientRect().top;
      var h = Math.round(window.innerHeight - topPx) + 'px';
      if (h !== lastFitH) { // called per-frame while open — write only real changes
        lastFitH = h;
        panel.style.height = h;
        panel.style.maxHeight = h;
      }
    }
    window.addEventListener('resize', function () {
      if (panel.classList.contains('filter-panel--active')) { fitPanelHeight(); }
    });
    // the FILTER button flips between in-flow (title row) and pinned (is-stuck)
    // on scroll — the stick watcher calls this so an OPEN panel re-fits to the
    // button's new position instead of keeping a stale height
    window.theme = window.theme || {};
    window.theme.fitFilterPanel = function () {
      if (panel.classList.contains('filter-panel--active')) { fitPanelHeight(); }
    };

    // Toggle panel open/close
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-filter-toggle]');
      if (toggle) {
        e.preventDefault();
        togglePanel();
        return;
      }

      // Close when clicking outside the panel (and not on the toggle).
      // Clicks inside the panel (accordions, checkboxes, search, Apply) fall through.
      if (
        panel.classList.contains('filter-panel--active') &&
        !e.target.closest('[data-filter-panel]') &&
        !e.target.closest('[data-filter-toggle]')
      ) {
        togglePanel(false);
        return;
      }

      // Close button
      if (e.target.closest('[data-filter-close]')) {
        e.preventDefault();
        togglePanel(false);
        return;
      }

      // Accordion toggles
      var accToggle = e.target.closest('[data-accordion-toggle]');
      if (accToggle) {
        e.preventDefault();
        var group = accToggle.closest('[data-accordion-group]');
        var content = group.querySelector('[data-accordion-content]');
        var icon = accToggle.querySelector('.filter-panel__summary-icon');
        var isOpen = content.classList.contains('filter-panel__content--open');
        if (!isOpen && window.matchMedia('(max-width: 749px)').matches && !content.querySelector('[data-price-slider]')) {
          // mobile only: exclusive accordion \u2014 opening one LIST group
          // compresses the others. Price stays out of it both ways (it
          // neither closes others nor gets closed by them). Desktop keeps
          // groups independently open; the shared grow CSS gives whichever
          // stays open the full panel height.
          var panelEl = group.closest('.filter-panel') || panel;
          panelEl.querySelectorAll('[data-accordion-content].filter-panel__content--open').forEach(function (other) {
            if (other.querySelector('[data-price-slider]')) { return; }
            other.classList.remove('filter-panel__content--open');
            var og = other.closest('[data-accordion-group]');
            var oi = og && og.querySelector('.filter-panel__summary-icon');
            if (oi) { oi.textContent = '+'; }
          });
        }
        content.classList.toggle('filter-panel__content--open');
        icon.textContent = isOpen ? '+' : '\u2212';
        return;
      }
    });

    // Filter form submit
    var filterForm = panel.querySelector('[data-filter-form]');
    // on /search the filter URLs must keep the query itself
    function seedSearchParams(params) {
      var cur = new URLSearchParams(window.location.search);
      ['q', 'type'].forEach(function (k) {
        if (cur.get(k)) { params.append(k, cur.get(k)); }
      });
      return params;
    }

    // In-stock lock. A size option filter on its own matches any product that
    // COMES in that size, sold out in it or not. Shopify applies variant filters
    // to the same variant, so sending availability=in stock alongside the size
    // narrows it to products with that size actually in stock. The lock is a
    // hidden checkbox the section renders (only when the store has an
    // Availability filter), so it rides along in every param collector below.
    // It is ticked only while a size is selected — no size, nothing changes.
    var inStockLock = filterForm ? filterForm.querySelector('[data-instock-lock]') : null;
    function syncInStockLock() {
      if (!inStockLock) { return; }
      inStockLock.checked = !!filterForm.querySelector('input[data-size-filter]:checked');
    }
    if (inStockLock) {
      syncInStockLock();
      // registered before the facet/instant-removal listener below so the lock
      // is already up to date by the time those read the checked boxes
      filterForm.addEventListener('change', syncInStockLock);
    }

    if (filterForm) {
      filterForm.addEventListener('submit', function (e) {
        e.preventDefault();
        syncInStockLock();

        // Apply vendor filter client-side first
        if (window.applyVendorFilter) window.applyVendorFilter();

        // Build server-side params
        var params = seedSearchParams(new URLSearchParams());
        var hasServerParams = false;

        // Collect named checkboxes (not vendor, not sale)
        filterForm.querySelectorAll('input[type="checkbox"]:checked').forEach(function (cb) {
          if (cb.name && !cb.hasAttribute('data-sale-toggle') && !cb.hasAttribute('data-vendor-filter')) {
            params.append(cb.name, cb.value);
            hasServerParams = true;
          }
        });

        // Sort - only include if changed from default
        var sortSelect = filterForm.querySelector('[data-sort-select]');
        if (sortSelect && sortSelect.value && sortSelect.value !== sortSelect.options[0].value) {
          params.append('sort_by', sortSelect.value);
          hasServerParams = true;
        }

        // Price inputs
        filterForm.querySelectorAll('input[type="number"]').forEach(function (el) {
          if (el.name && el.value) {
            params.append(el.name, el.value);
            hasServerParams = true;
          }
        });

        // Sale toggle
        var base = window.location.pathname;
        var saleToggle = panel.querySelector('[data-sale-toggle]');
        var saleActive = saleToggle && saleToggle.checked;
        var currentlyOnSale = base.match(/\/sale\/?$/);

        if (saleActive && !currentlyOnSale) {
          if (base.charAt(base.length - 1) !== '/') base += '/';
          base += 'sale';
          hasServerParams = true;
        } else if (!saleActive && currentlyOnSale) {
          base = base.replace(/\/sale\/?$/, '');
          hasServerParams = true;
        }

        if (hasServerParams) {
          var qs = params.toString();
          window.location.href = base + (qs ? '?' + qs : '');
        } else {
          togglePanel(false);
        }
      });
    }

    // Facet refresh — when a server-backed option changes in the panel (e.g.
    // deselecting a Category), refetch this section's markup for the WOULD-BE
    // url (Section Rendering API) and swap the refreshed option lists (Size…)
    // into the open panel. Other facets broaden/narrow immediately — nothing
    // is applied to the page/grid until the user hits Apply.
    if (filterForm) {
      var facetSection = filterForm.closest('.shopify-section');
      var facetSectionId = facetSection ? facetSection.id.replace(/^shopify-section-/, '') : null;
      var facetAbort = null, facetTimer = null;

      var groupLabel = function (g) {
        var s = g.querySelector('[data-accordion-toggle] span');
        return s ? s.textContent.trim() : '';
      };

      // Filter permanence: the instant filter-removal reload stashes the
      // panel's state (open, expanded accordions, scroll) and restores it
      // here so the panel reopens exactly as the user left it.
      function saveFilterPanelState() {
        try {
          var open = [];
          panel.querySelectorAll('[data-accordion-group]').forEach(function (g) {
            var content = g.querySelector('[data-accordion-content]');
            if (content && content.classList.contains('filter-panel__content--open')) { open.push(groupLabel(g)); }
          });
          var body = panel.querySelector('.filter-panel__body');
          // Brand/Category option lists scroll inside their own containers —
          // record each group's list scroll too, keyed by group label
          var listScrolls = {};
          panel.querySelectorAll('[data-accordion-group]').forEach(function (g) {
            var list = g.querySelector('.filter-panel__list');
            if (list && list.scrollTop > 0) { listScrolls[groupLabel(g)] = list.scrollTop; }
          });
          sessionStorage.setItem('filterPanelState', JSON.stringify({
            path: window.location.pathname,
            open: open,
            scroll: body ? body.scrollTop : 0,
            listScrolls: listScrolls
          }));
        } catch (err) {}
      }
      try {
        var savedPanel = sessionStorage.getItem('filterPanelState');
        if (savedPanel) {
          sessionStorage.removeItem('filterPanelState');
          savedPanel = JSON.parse(savedPanel);
          if (savedPanel.path === window.location.pathname) {
            togglePanel(true);
            panel.querySelectorAll('[data-accordion-group]').forEach(function (g) {
              var content = g.querySelector('[data-accordion-content]');
              var icon = g.querySelector('.filter-panel__summary-icon');
              if (!content) { return; }
              var shouldOpen = savedPanel.open.indexOf(groupLabel(g)) !== -1;
              content.classList.toggle('filter-panel__content--open', shouldOpen);
              if (icon) { icon.textContent = shouldOpen ? '\u2212' : '+'; }
            });
            var savedBody = panel.querySelector('.filter-panel__body');
            requestAnimationFrame(function () {
              if (savedBody) { savedBody.scrollTop = savedPanel.scroll || 0; }
              var ls = savedPanel.listScrolls || {};
              panel.querySelectorAll('[data-accordion-group]').forEach(function (g) {
                var list = g.querySelector('.filter-panel__list');
                var want = ls[groupLabel(g)];
                if (list && want) { list.scrollTop = want; }
              });
            });
          }
        }
      } catch (err) {}

      function facetUrl() {
        var params = seedSearchParams(new URLSearchParams());
        filterForm.querySelectorAll('input[type="checkbox"]:checked').forEach(function (cb) {
          if (cb.name && !cb.hasAttribute('data-sale-toggle') && !cb.hasAttribute('data-vendor-filter')) {
            params.append(cb.name, cb.value);
          }
        });
        filterForm.querySelectorAll('input[type="number"]').forEach(function (el) {
          if (el.name && el.value) { params.append(el.name, el.value); }
        });
        // same sale-path logic as Apply so facet counts match what Apply shows
        var base = window.location.pathname;
        var saleToggle = panel.querySelector('[data-sale-toggle]');
        var currentlyOnSale = base.match(/\/sale\/?$/);
        if (saleToggle && saleToggle.checked && !currentlyOnSale) {
          base += (base.charAt(base.length - 1) !== '/' ? '/' : '') + 'sale';
        } else if (saleToggle && !saleToggle.checked && currentlyOnSale) {
          base = base.replace(/\/sale\/?$/, '');
        }
        params.append('section_id', facetSectionId);
        return base + '?' + params.toString();
      }

      function refreshFacets() {
        if (!facetSectionId) { return; }
        if (facetAbort) { facetAbort.abort(); }
        facetAbort = new AbortController();
        fetch(facetUrl(), { signal: facetAbort.signal })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            doc.querySelectorAll('[data-accordion-group]').forEach(function (fresh) {
              var name = groupLabel(fresh);
              // Category/Brand hold the user's in-progress selection; Sort and
              // the price slider have their own state — only swap list facets
              // like Size that the server recomputes per scope.
              if (!name || name === 'Category' || name === 'Brand' || name === 'Brands' || name === 'Sort') { return; }
              var freshList = fresh.querySelector('.filter-panel__list');
              if (!freshList) { return; }
              panel.querySelectorAll('[data-accordion-group]').forEach(function (g) {
                if (groupLabel(g) === name) {
                  var list = g.querySelector('.filter-panel__list');
                  if (list) { list.innerHTML = freshList.innerHTML; }
                }
              });
            });
          })
          .catch(function () { /* aborted or offline — keep current options */ });
      }

      filterForm.addEventListener('change', function (e) {
        var cb = e.target;
        if (!cb || cb.type !== 'checkbox') { return; }
        // client-only filters (brand/type over the loaded grid) don't change
        // the server's facet scope — no refetch needed
        if (cb.hasAttribute('data-vendor-filter') || cb.hasAttribute('data-type-filter')) { return; }
        // Unticking an APPLIED filter removes it from the page instantly (no
        // Apply needed). Server-applied boxes render with checked markup, so
        // defaultChecked distinguishes them from boxes ticked this session.
        if (cb.name && cb.defaultChecked && !cb.checked && !cb.hasAttribute('data-sale-toggle')) {
          saveFilterPanelState(); // reopen in the same state after the reload
          var params = seedSearchParams(new URLSearchParams());
          filterForm.querySelectorAll('input[type="checkbox"]:checked').forEach(function (b) {
            if (b.name && !b.hasAttribute('data-sale-toggle') && !b.hasAttribute('data-vendor-filter')) { params.append(b.name, b.value); }
          });
          filterForm.querySelectorAll('input[type="number"]').forEach(function (el) {
            if (el.name && el.value) { params.append(el.name, el.value); }
          });
          var sortSel = filterForm.querySelector('[data-sort-select]');
          if (sortSel && sortSel.value && sortSel.value !== sortSel.options[0].value) { params.append('sort_by', sortSel.value); }
          var qs = params.toString();
          window.location.href = window.location.pathname + (qs ? '?' + qs : '');
          return;
        }
        clearTimeout(facetTimer);
        facetTimer = setTimeout(refreshFacets, 350);
      });
    }

    // Sort applies on Apply (no auto-submit — the user clicks Apply to refresh)

    // Search within dropdowns
    panel.querySelectorAll('[data-filter-search]').forEach(function (input) {
      input.addEventListener('input', function () {
        var query = input.value.toLowerCase().trim();
        var list = input.parentElement.querySelector('[data-filter-list]') || input.nextElementSibling;
        if (!list) return;
        list.querySelectorAll('li').forEach(function (item) {
          var text = item.textContent.toLowerCase();
          item.style.display = text.indexOf(query) !== -1 ? '' : 'none';
        });
      });
    });

    // Brand filter - client-side filtering by vendor
    // Client-side grid filters (Brand + Category multi-select) — hide loaded
    // grid items without navigating. Infinite scroll keeps fetching pages and
    // re-applies this to each appended batch, so hidden batches cascade the
    // trigger into view until everything is loaded.
    window.applyClientFilters = function() {
      // reveal tag-view categories once an item of that type has actually loaded
      var seenTypes = {};
      document.querySelectorAll('.main-collection__products .product-grid__item[data-product-type]').forEach(function (i) {
        seenTypes[(i.getAttribute('data-product-type') || '').trim().toLowerCase()] = 1;
      });
      document.querySelectorAll('.filter-panel__item--unconfirmed').forEach(function (li) {
        if (seenTypes[(li.getAttribute('data-filter-value') || '')]) {
          li.hidden = false;
          li.classList.remove('filter-panel__item--unconfirmed');
        }
      });
      // A data-nav-current checkbox marks the brand/category you're ALREADY
      // viewing — it's a navigation control, not a product filter. Filtering
      // by it is redundant and breaks when the vendor name differs from the
      // collection title (e.g. collection "Frog" but vendor "Frog
      // Skateboards"), which would hide every product. Skip it.
      var vendors = [], types = [];
      document.querySelectorAll('[data-vendor-filter]:checked').forEach(function (cb) {
        if (cb.hasAttribute('data-nav-current')) { return; }
        vendors.push(cb.value.trim().toLowerCase());
      });
      document.querySelectorAll('[data-type-filter]:checked').forEach(function (cb) {
        if (cb.hasAttribute('data-nav-current')) { return; }
        types.push(cb.value.trim().toLowerCase());
      });
      document.querySelectorAll('.main-collection__products .product-grid__item').forEach(function (card) {
        var vendor = (card.getAttribute('data-product-vendor') || '').trim().toLowerCase();
        var type = (card.getAttribute('data-product-type') || '').trim().toLowerCase();
        var ok = (vendors.length === 0 || vendors.indexOf(vendor) !== -1) &&
                 (types.length === 0 || types.indexOf(type) !== -1);
        card.style.display = ok ? '' : 'none';
      });
    };
    window.applyVendorFilter = window.applyClientFilters; // back-compat alias

    document.querySelectorAll('[data-vendor-filter], [data-type-filter]').forEach(function (cb) {
      cb.addEventListener('change', function () {
        // on a brand page the brand list navigates between brand collections
        // (likewise categories on a category page) — the current one is
        // pre-ticked; unticking it falls back to the full store view
        if (cb.hasAttribute('data-nav-url')) {
          if (cb.hasAttribute('data-nav-current')) {
            // back to the STORE view (the nav's Store target), not /collections/all
            if (!cb.checked) { window.location.href = '/collections/all-brands'; }
            return;
          }
          if (cb.checked) { window.location.href = cb.getAttribute('data-nav-url'); return; }
        }
        window.applyClientFilters();
      });
    });
    window.applyClientFilters(); // initial pass (reveals confirmed tag-view categories)

  }

  /* ------------------------------------------------------------------ */
  /*  5. Product Page                                                    */
  /* ------------------------------------------------------------------ */

  // Afterpay widget: its shadow stylesheet clamps the logo at min 50x20px —
  // too big next to the 13px line. The shadow root is open, so inject a
  // style that lets the lockup size down to text height (kept in place by a
  // MutationObserver in case the widget re-renders).
  function initAfterpayLogoSize() {
    var css = '.afterpay-logo.brand-afterpay, .afterpay-logo.brand-afterpay svg{' +
      'width:56px !important;min-width:0 !important;min-height:0 !important;height:auto !important;}' +
      '.afterpay-logo.brand-afterpay svg{vertical-align:middle !important;transform:translateY(1.5px);}' +
      '.afterpay-paragraph{display:flex;align-items:center;flex-wrap:wrap;gap:0 4px;}';
    function apply(sq) {
      if (!sq.shadowRoot) { return false; }
      if (!sq.shadowRoot.querySelector('#lofi-afterpay-fix')) {
        var st = document.createElement('style');
        st.id = 'lofi-afterpay-fix';
        st.textContent = css;
        sq.shadowRoot.appendChild(st);
        new MutationObserver(function () {
          if (!sq.shadowRoot.querySelector('#lofi-afterpay-fix')) {
            var st2 = document.createElement('style');
            st2.id = 'lofi-afterpay-fix';
            st2.textContent = css;
            sq.shadowRoot.appendChild(st2);
          }
        }).observe(sq.shadowRoot, { childList: true });
      }
      return true;
    }
    var tries = 0;
    (function poll() {
      var sq = document.querySelector('square-placement');
      if (sq && apply(sq)) { return; }
      if (tries++ < 40) { setTimeout(poll, 250); }
    })();
  }

  // Third-party apps (Customizery grip selects) validate via window.alert and
  // add to cart via form.submit() — which skips submit listeners and lands on
  // the cart PAGE. Reroute both into the theme's flow: alerts render as a red
  // line under the buy button, programmatic submits go through the drawer.
  function initFormErrorBridge() {
    var form = document.querySelector('[data-product-form]');
    if (!form) { return; }
    var slot = document.createElement('p');
    slot.className = 'main-product__form-error';
    slot.hidden = true;
    form.parentElement.appendChild(slot);
    window.theme = window.theme || {};
    window.theme.setFormError = function (msg) {
      slot.textContent = msg || '';
      slot.hidden = !msg;
    };
    var nativeAlert = window.alert.bind(window);
    window.alert = function (msg) {
      var m = String(msg || '');
      if (/select an option|add.*to cart/i.test(m)) { window.theme.setFormError(m); return; }
      nativeAlert(msg);
    };
    // clear the error once the shopper fixes their selection
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('.main-product__info')) {
        window.theme.setFormError('');
      }
    });
    form.submit = function () { handleAddToCart(form, false); };
  }

  // Header dropdown persistence: once a nav item's subrow opens, keep it
  // open until the pointer leaves the HEADER entirely (hover-gap between the
  // pill and the subrow, or wandering to a sibling, shouldn't close it).
  function initNavSubrowHold() {
    var header = document.querySelector('.site-header');
    if (!header || !window.matchMedia('(hover: hover)').matches) { return; }
    var items = header.querySelectorAll('.site-nav__item--has-dropdown');
    if (!items.length) { return; }
    var openItem = null;
    function close() {
      if (openItem) { openItem.classList.remove('site-nav__item--open'); openItem = null; }
    }
    items.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        if (openItem && openItem !== item) { openItem.classList.remove('site-nav__item--open'); }
        openItem = item;
        item.classList.add('site-nav__item--open');
      });
    });
    header.addEventListener('mouseleave', close);
    // safety: close when the mobile menu / search take over
    document.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('.site-header')) { close(); }
    });
  }

  function initProductPage() {
    var productJsonEl = document.querySelector('[data-product-json]');
    if (!productJsonEl) return;
    initFormErrorBridge();
    initAfterpayLogoSize();

    var product;
    try {
      product = JSON.parse(productJsonEl.textContent);
    } catch (err) {
      console.error('Failed to parse product JSON:', err);
      return;
    }

    // Build a variant lookup map
    function findVariantByOptions(selectedOptions) {
      return product.variants.find(function (variant) {
        return variant.options.every(function (opt, i) {
          return opt === selectedOptions[i];
        });
      });
    }

    function getSelectedOptions() {
      var options = [];
      product.options.forEach(function (optionObj, index) {
        // Button picker: radios are named "option-{index}".
        var checked = document.querySelector('[data-option-input][name="option-' + index + '"]:checked');
        if (checked) {
          options[index] = checked.value;
        } else {
          // Dropdown picker: a <select> with data-option-index.
          var select = document.querySelector('[data-option-select][data-option-index="' + index + '"]');
          if (select) {
            options[index] = select.value;
          }
        }
      });
      return options;
    }

    function updateVariantUI() {
      var selectedOptions = getSelectedOptions();
      var variant = findVariantByOptions(selectedOptions);

      var variantIdInput = document.querySelector('[data-variant-id]');
      var priceEl = document.querySelector('[data-product-price]');
      var addBtn = document.querySelector('[data-product-form] button[type="submit"], [data-product-form] [type="submit"]');
      var mainImage = document.querySelector('[data-product-image]');

      if (variant) {
        if (variantIdInput) variantIdInput.value = variant.id;
        if (priceEl) {
          // mirror snippets/price.liquid so the compare-at strike-through
          // survives variant changes on sale items
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            var pctOff = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
            priceEl.innerHTML =
              '<span class="price price--on-sale">' +
                '<span class="price__compare">' + formatMoney(variant.compare_at_price) + '</span>' +
                '<span class="price__regular price__regular--sale">' + formatMoney(variant.price) + '</span>' +
                '<span class="price__discount">' + pctOff + '% Off</span>' +
              '</span>';
          } else {
            priceEl.innerHTML =
              '<span class="price"><span class="price__regular">' + formatMoney(variant.price) + '</span></span>';
          }
        }

        // Update main image if variant has featured image
        if (variant.featured_image && variant.featured_image.src && mainImage) {
          mainImage.src = variant.featured_image.src;
          if (mainImage.srcset) {
            mainImage.srcset = variant.featured_image.src;
          }
        }

        if (addBtn) {
          if (variant.available) {
            addBtn.disabled = false;
            addBtn.textContent = window.theme.strings.addToCartSelected || window.theme.strings.addToCart;
          } else {
            addBtn.disabled = true;
            addBtn.textContent = window.theme.strings.soldOut;
          }
        }
      } else if (addBtn) {
        // No matching variant for the chosen combination
        addBtn.disabled = true;
        addBtn.textContent = window.theme.strings.unavailable;
      }

      // The Afterpay snippet hides its widget on any change event whose target
      // has no form ancestor — and our option pickers sit OUTSIDE the product
      // form. Re-fire the change from the form's id input (which IS inside the
      // form) so Afterpay re-reads the variant and shows/hides itself correctly.
      if (variantIdInput) {
        variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    document.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-input], [data-option-select]')) {
        updateVariantUI();
      }
    });

    // Same Afterpay quirk, wider net: ANY change event outside a form (e.g. the
    // header currency select) makes the snippet hide its widget. Re-fire from
    // the product form's id input so it re-evaluates. Registered after the
    // listener above so the id input already holds the new variant.
    document.addEventListener('change', function (e) {
      if (e.target.closest('form') || e.target.closest('[data-option-input], [data-option-select]')) { return; }
      var idInput = document.querySelector('[data-product-form] [data-variant-id]');
      if (idInput) {
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    // A radio that's already selected won't fire 'change' when re-clicked, so
    // also update on click (deferred until the radio's checked state settles).
    document.addEventListener('click', function (e) {
      if (e.target.closest('.main-product__option-btn, [data-option-input]')) {
        setTimeout(updateVariantUI, 0);
      }
    });

    // Image gallery thumbnails — scroll to the target image WITHOUT changing the
    // URL hash, so tapping through images never pushes browser-history entries
    // (browser BACK then leaves the product entirely instead of stepping through
    // each photo). Works for both the desktop vertical stack and the mobile
    // horizontal swipe carousel.
    document.addEventListener('click', function (e) {
      var thumb = e.target.closest('.main-product__thumbnail');
      if (!thumb) return;
      e.preventDefault();
      var href = thumb.getAttribute('href') || '';
      var id = href.charAt(0) === '#' ? href.slice(1) : '';
      var target = id ? document.getElementById(id) : null;
      if (!target) return;
      var gallery = target.closest('.main-product__gallery');
      if (gallery && gallery.scrollWidth > gallery.clientWidth + 4) {
        // Horizontal carousel (mobile): scroll the gallery, not the page.
        var wraps = Array.prototype.slice.call(gallery.querySelectorAll('.main-product__image-wrap'));
        var idx = wraps.indexOf(target);
        gallery.scrollTo({ left: idx * gallery.clientWidth, behavior: 'smooth' });
      } else {
        // Vertical stack (desktop): centre the image vertically in the viewport.
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      document.querySelectorAll('.main-product__thumbnail').forEach(function (t) {
        t.classList.remove('main-product__thumbnail--active');
      });
      thumb.classList.add('main-product__thumbnail--active');
    });

    // Quantity selector
    document.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-quantity-minus]');
      var plus = e.target.closest('[data-quantity-plus]');
      if (!minus && !plus) return;
      e.preventDefault();

      var container = (minus || plus).parentElement;
      var input = container.querySelector('[data-quantity-input]');
      if (!input) return;

      var val = parseInt(input.value, 10) || 1;
      if (minus && val > 1) {
        input.value = val - 1;
      } else if (plus) {
        input.value = val + 1;
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /*  6. Sticky Header                                                   */
  /* ------------------------------------------------------------------ */

  function initStickyHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;

    var threshold = 100;
    var ticking = false;

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          if (window.scrollY > threshold) {
            header.classList.add('site-header--scrolled');
          } else {
            header.classList.remove('site-header--scrolled');
          }
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    // Run once on load
    onScroll();
  }

  /* ------------------------------------------------------------------ */
  /*  7. Marquee Ticker                                                  */
  /* ------------------------------------------------------------------ */

  function initMarquee() {
    var marquees = document.querySelectorAll('.marquee');
    marquees.forEach(function (marquee) {
      var content = marquee.querySelector('.marquee__content');
      if (!content) return;
      // Duplicate content for seamless loop
      var clone = content.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      marquee.appendChild(clone);
    });
  }

  /* ------------------------------------------------------------------ */
  /*  8. Collection Sort                                                 */
  /* ------------------------------------------------------------------ */

  function initCollectionSort() {
    document.addEventListener('change', function (e) {
      var select = e.target.closest('[data-sort-select]');
      if (!select) return;
      // The filter panel form handles sort (preserving active filters); avoid double-nav
      if (document.querySelector('[data-filter-form]')) return;
      var value = select.value;
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', value);
      window.location.href = url.toString();
    });
  }

  /* ------------------------------------------------------------------ */
  /*  9. Product Card Hover Sizes                                        */
  /* ------------------------------------------------------------------ */

  function initProductCardHover() {
    // Only on hover-capable devices
    if (!window.matchMedia('(hover: hover)').matches) return;

    document.addEventListener('mouseenter', function (e) {
      if (!e.target || typeof e.target.closest !== 'function') return;
      var card = e.target.closest('.product-card');
      if (!card) return;
      var sizes = card.querySelector('.product-card__sizes');
      if (sizes) sizes.style.display = '';
    }, true);

    document.addEventListener('mouseleave', function (e) {
      if (!e.target || typeof e.target.closest !== 'function') return;
      var card = e.target.closest('.product-card');
      if (!card) return;
      var sizes = card.querySelector('.product-card__sizes');
      if (sizes) sizes.style.display = 'none';
    }, true);
  }

  // Hover (secondary) card images render WITHOUT src — touch devices never
  // fetch them. On hover-capable devices they PRELOAD once the card nears the
  // viewport (idle-time, small concurrency), so the swap is instant by the
  // time the cursor arrives; first-hover fetch remains as the fallback.
  function initHoverImageLoad() {
    if (!window.matchMedia('(hover: hover)').matches) { return; }

    function loadHoverImg(img, urgent) {
      if (!img || !img.getAttribute('data-src')) { return; }
      // a hover-triggered fetch jumps the browser's request queue
      if (urgent && 'fetchPriority' in img) { img.fetchPriority = 'high'; }
      img.srcset = img.getAttribute('data-srcset') || '';
      img.src = img.getAttribute('data-src');
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    }

    // idle preloader: starts once primaries have settled, then drains fast
    var queue = [], inFlight = 0, started = false;
    function pump() {
      while (inFlight < 6 && queue.length) {
        var img = queue.shift();
        if (!img.getAttribute('data-src')) { continue; }
        inFlight++;
        var done = function () { inFlight--; pump(); };
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', done, { once: true });
        loadHoverImg(img);
      }
    }
    function enqueue(img) {
      queue.push(img);
      if (started) { pump(); }
    }
    // hold until the page has loaded (or 3s) so preloads never slow first paint
    function start() { if (!started) { started = true; pump(); } }
    if (document.readyState === 'complete') { setTimeout(start, 100); }
    else { window.addEventListener('load', function () { setTimeout(start, 100); }); }
    setTimeout(start, 1500);

    if (window.IntersectionObserver) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) { return; }
          io.unobserve(en.target);
          enqueue(en.target);
        });
      }, { rootMargin: '1200px 0px' }); // start well ahead of the scroll
      var watch = function (root) {
        (root.querySelectorAll ? root : document)
          .querySelectorAll('.product-card__image--secondary[data-src]')
          .forEach(function (img) { io.observe(img); });
      };
      watch(document);
      // infinite scroll appends new cards — watch those too
      new MutationObserver(function (muts) {
        muts.forEach(function (m) {
          m.addedNodes.forEach(function (n) {
            if (n.nodeType === 1) { watch(n); }
          });
        });
      }).observe(document.body, { childList: true, subtree: true });
    }

    document.addEventListener('pointerenter', function (e) {
      if (!e.target || typeof e.target.closest !== 'function') { return; }
      var card = e.target.closest('.product-card--has-hover');
      if (!card) { return; }
      var img = card.querySelector('.product-card__image--secondary[data-src]');
      if (img) {
        loadHoverImg(img, true);
      }
      // the CSS swap is gated on --hover-ready so the primary never hides
      // before the hover shot has finished downloading
      if (!card.classList.contains('product-card--hover-ready')) {
        var sec = img || card.querySelector('.product-card__image--secondary');
        if (sec) {
          if (sec.complete && sec.naturalWidth) {
            card.classList.add('product-card--hover-ready');
          } else {
            sec.addEventListener('load', function () {
              card.classList.add('product-card--hover-ready');
            }, { once: true });
          }
        }
      }
    }, true);
  }

  // Hover (secondary) card images: lifestyle/detail shots zoom to fill the
  // frame, but product-cutout shots (mostly-white border ring, same style as
  // the primary) stay contained so they read the same size as the photo they
  // replace. Classified by sampling the image's border ring on a canvas.
  function initHoverImageFit() {
    var canvas, ctx;
    function classify(img) {
      if (img.dataset.fitDone) { return; }
      try {
        if (!ctx) {
          canvas = document.createElement('canvas');
          ctx = canvas.getContext('2d', { willReadFrequently: true });
        }
        var S = 48;
        canvas.width = S; canvas.height = S;
        ctx.drawImage(img, 0, 0, S, S);
        var d = ctx.getImageData(0, 0, S, S).data;
        var edge = 5, ring = 0, light = 0;
        for (var y = 0; y < S; y++) {
          for (var x = 0; x < S; x++) {
            if (x >= edge && x < S - edge && y >= edge && y < S - edge) { continue; }
            var i = (y * S + x) * 4;
            ring++;
            // transparent counts as white — cutout PNGs on alpha render on the
            // card's white background (the canvas reads their ring as black)
            if (d[i + 3] < 128 || (d[i] > 236 && d[i + 1] > 236 && d[i + 2] > 236)) { light++; }
          }
        }
        img.dataset.fitDone = '1';
        // border ring not mostly white → the shot fills the frame → zoom (cover).
        // 0.7, not 0.9: back-of-product cutouts where the garment touches the
        // frame score 0.80–0.89 (white studio bg minus the garment) and must
        // stay contained; measured lifestyle shots top out around 0.55.
        if (light / ring < 0.7) { img.classList.add('product-card__image--fill'); }
      } catch (e) { img.dataset.fitDone = '1'; } // tainted canvas → leave contained
    }
    function bindAll(root) {
      (root || document).querySelectorAll('.product-card__image--secondary').forEach(function (img) {
        if (img.dataset.fitBound) { return; }
        img.dataset.fitBound = '1';
        if (img.complete && img.naturalWidth) { classify(img); }
        else { img.addEventListener('load', function () { classify(img); }, { once: true }); }
      });
    }
    bindAll(document);
    // cards appended later (search infinite scroll) announce themselves
    document.addEventListener('theme:cards-added', function (e) {
      bindAll(e.detail && e.detail.root);
    });
  }

  // First visit in a session the header shows the ORIGINAL wordmark (class set
  // pre-paint by an inline snippet in theme.liquid). Once the visitor settles
  // in — ≥5s on the site, some scrolling and 2 clicks, counted ACROSS pages —
  // it flips to the interactive ASCII logo for the rest of the visit.
  function initLogoIntro() {
    var root = document.documentElement;
    if (!root.classList.contains('logo-intro')) { return; }
    function sGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
    function sSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
    var t0 = parseInt(sGet('lofiIntroT0'), 10);
    if (!t0) { t0 = Date.now(); sSet('lofiIntroT0', t0); }
    var clicks = parseInt(sGet('lofiIntroClicks'), 10) || 0;
    var scrolled = sGet('lofiIntroScrolled') === '1';
    var done = false;

    function reveal() {
      done = true;
      sSet('lofiLogoIntroDone', '1');
      // crossfade: unhide the (already running) ascii canvas under the wordmark,
      // then fade wordmark out / canvas in, then drop the intro classes
      root.classList.add('logo-intro-out');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { root.classList.add('logo-intro-go'); });
      });
      setTimeout(function () {
        root.classList.remove('logo-intro', 'logo-intro-out', 'logo-intro-go');
      }, 850);
    }
    function maybeReveal() {
      if (done) { return; }
      if (Date.now() - t0 >= 5000 && scrolled && clicks >= 2) { reveal(); }
    }
    document.addEventListener('click', function () {
      if (done) { return; }
      clicks++; sSet('lofiIntroClicks', clicks);
      maybeReveal();
    }, true);
    ['wheel', 'touchmove', 'scroll'].forEach(function (ev) {
      window.addEventListener(ev, function () {
        if (done || scrolled) { maybeReveal(); return; }
        scrolled = true; sSet('lofiIntroScrolled', '1');
        maybeReveal();
      }, { passive: true, capture: true });
    });
    // if scroll+clicks landed inside the first 5s, time is the last gate
    var wait = Math.max(0, 5000 - (Date.now() - t0));
    setTimeout(maybeReveal, wait + 50);
  }

  // Display-currency converter. The store + checkout stay AUD — the header
  // toggle converts every DISPLAYED "A$…" amount using daily FX rates
  // (frankfurter.app / ECB, cached 12h in localStorage). Each price text node's
  // original AUD string is remembered so switching is always exact, and a
  // MutationObserver re-converts anything re-rendered (cart drawer, variant
  // price, infinite scroll).
  function initCurrencyToggle() {
    var sel = document.querySelector('[data-currency-select]');
    if (!sel) { return; }
    var SYMBOL = { AUD: 'A$', USD: 'US$', EUR: '€', GBP: '£', JPY: '¥', NZD: 'NZ$', CAD: 'C$', SGD: 'S$' };
    var ZERO_DECIMALS = { JPY: true, KRW: true };
    var RX = /A\$\s?([\d,]+(?:\.\d+)?)/g;
    var originals = new Map(); // text node -> original AUD string
    var rates = null, current = 'AUD';

    function getRates() {
      if (rates) { return Promise.resolve(rates); }
      try {
        var cached = JSON.parse(localStorage.getItem('lofi-fx') || 'null');
        if (cached && Date.now() - cached.t < 43200000) { rates = cached.rates; return Promise.resolve(rates); } // 12h cache (ECB rates only change daily)
      } catch (e) {}
      return fetch('https://api.frankfurter.dev/v1/latest?base=AUD')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          rates = d.rates;
          try { localStorage.setItem('lofi-fx', JSON.stringify({ t: Date.now(), rates: rates })); } catch (e) {}
          return rates;
        });
    }

    function convertText(text, code) {
      return text.replace(RX, function (m, num) {
        var amount = parseFloat(num.replace(/,/g, ''));
        if (isNaN(amount)) { return m; }
        var v = amount * rates[code];
        var digits = ZERO_DECIMALS[code] ? 0 : 2;
        return SYMBOL[code] + v.toLocaleString('en-US', { minimumFractionDigits: digits, maximumFractionDigits: digits });
      });
    }

    function applyTo(root) {
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode: function (node) {
          var p = node.parentElement;
          if (!p || p.closest('script, style, select, [data-no-fx]')) { return NodeFilter.FILTER_REJECT; }
          RX.lastIndex = 0;
          return (originals.has(node) || RX.test(node.textContent)) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
      });
      var node;
      while ((node = walker.nextNode())) {
        var base = originals.get(node);
        if (base == null) { base = node.textContent; originals.set(node, base); }
        var want = (current === 'AUD') ? base : convertText(base, current);
        // cart totals carry the real AUD charge in brackets after the estimate
        if (current !== 'AUD' && node.parentElement &&
            node.parentElement.closest('[data-cart-subtotal], [data-cart-total], .main-cart__subtotal, [data-shipping-total]')) {
          // "$159.95 AUD" reads clearer than the A$ prefix in brackets
          want = want + ' (' + base.trim().replace(/^A\$/, '$') + ' AUD)';
        }
        // only write real changes — our own writes fire the MutationObserver,
        // so unconditional writes would loop
        if (node.textContent !== want) { node.textContent = want; }
      }
      // disclaimer: estimates only, checkout charges AUD
      document.querySelectorAll('[data-fx-note]').forEach(function (n) {
        n.hidden = current === 'AUD';
      });
    }

    var pending = null;
    function scheduleApply() {
      if (pending) { return; }
      pending = requestAnimationFrame(function () { pending = null; applyTo(document.body); });
    }

    var observer = new MutationObserver(function () {
      if (current !== 'AUD') { scheduleApply(); }
    });

    function setCurrency(code) {
      if (!SYMBOL[code]) { code = 'AUD'; }
      if (code === 'AUD') {
        current = 'AUD';
        observer.disconnect();
        applyTo(document.body);
        try { localStorage.setItem('lofi-currency', code); } catch (e) {}
        return;
      }
      getRates().then(function () {
        if (!rates || !rates[code]) { throw new Error('no rate'); }
        current = code;
        applyTo(document.body);
        observer.observe(document.body, { childList: true, characterData: true, subtree: true });
        try { localStorage.setItem('lofi-currency', code); } catch (e) {}
      }).catch(function () {
        current = 'AUD';
        sel.value = 'AUD';
        syncLabel();
      });
    }

    // mobile pill shows a span label (the real select is invisible there)
    var label = document.querySelector('[data-currency-label]');
    function syncLabel() { if (label) { label.textContent = sel.value; } }

    sel.addEventListener('change', function () { setCurrency(sel.value); syncLabel(); });

    var saved = null;
    try { saved = localStorage.getItem('lofi-currency'); } catch (e) {}
    if (saved && saved !== 'AUD' && SYMBOL[saved]) {
      sel.value = saved;
      setCurrency(saved);
    }
    syncLabel();
  }

  // Newsletter pop-up: a periwinkle tab stuck to the centre-right edge. Once
  // the visitor has settled in (>=8s on site + scrolled + 2 clicks, counted
  // across pages) it expands into the card with the ASCII animation + sign-up
  // form. X dismisses it for the session. Clicking the tab expands right away.
  function initNewsletterPop() {
    var pop = document.querySelector('[data-newsletter-pop]');
    if (!pop) { return; }
    var panel = pop.querySelector('[data-pop-panel]');
    function sGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
    function sSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
    if (sGet('lofiPopDismissed')) { return; } // stays hidden this session
    // collapse for the session once the visitor has browsed 5 pages — they've
    // seen the pitch; stop taking up edge space
    var pages = (parseInt(sGet('lofiPopPages'), 10) || 0) + 1;
    sSet('lofiPopPages', pages);
    if (pages > 5) { return; }
    pop.hidden = false;

    // Pin to the VISIBLE bottom edge on mobile. bottom:0 is measured against the
    // layout viewport, which Chrome on mobile keeps at its URL-bar-hidden height
    // — so mid-swipe, while the bar is sliding in or out, the strip drifts off
    // the bottom of the screen and only snaps back once the scroll settles. The
    // visual viewport is the part actually on screen, so track it and lift the
    // strip by the difference. Desktop reports no difference, so the transform
    // stays empty there. Also keeps the strip above the keyboard once the email
    // field has focus.
    var vv = window.visualViewport;
    if (vv) {
      var pinFrame = null;
      var placePop = function () {
        pinFrame = null;
        var gap = document.documentElement.clientHeight - (vv.height + vv.offsetTop);
        pop.style.transform = gap > 1 ? 'translateY(' + -gap + 'px)' : '';
      };
      var schedulePop = function () {
        if (pinFrame === null) { pinFrame = requestAnimationFrame(placePop); }
      };
      vv.addEventListener('resize', schedulePop);
      vv.addEventListener('scroll', schedulePop);
      window.addEventListener('orientationchange', schedulePop);
      placePop();
    }

    var expanded = false;
    function expand() {
      if (expanded) { return; }
      expanded = true;
      pop.classList.add('newsletter-pop--open');
      panel.hidden = false;
      sSet('lofiPopAutoDone', '1');
      // boot the ASCII animation now the box has real dimensions
      var el = pop.querySelector('[data-pop-ascii]');
      if (el && !el.__asciiBg && window.AsciiBackground) {
        el.__asciiBg = new window.AsciiBackground(el);
      }
    }

    pop.addEventListener('click', function (e) {
      if (e.target.closest('[data-pop-dismiss]')) {
        pop.hidden = true;
        sSet('lofiPopDismissed', '1');
        return;
      }
      if (e.target.closest('[data-pop-expand]')) { expand(); }
    });

    // returning from a form submit → open showing the success/error message
    if (window.location.search.indexOf('customer_posted=true') > -1 || pop.querySelector('.newsletter-pop__msg')) {
      expand();
      return;
    }
    if (sGet('lofiPopAutoDone')) { return; } // auto-expand only once — tab remains

    var t0 = parseInt(sGet('lofiPopT0'), 10);
    if (!t0) { t0 = Date.now(); sSet('lofiPopT0', t0); }
    var clicks = parseInt(sGet('lofiPopClicks'), 10) || 0;
    var scrolled = sGet('lofiPopScrolled') === '1';
    function maybeExpand() {
      if (expanded) { return; }
      if (Date.now() - t0 >= 8000 && scrolled && clicks >= 2) { expand(); }
    }
    document.addEventListener('click', function (e) {
      if (expanded) { return; }
      if (e.target.closest && e.target.closest('[data-newsletter-pop]')) { return; }
      clicks++; sSet('lofiPopClicks', clicks);
      maybeExpand();
    }, true);
    ['wheel', 'touchmove', 'scroll'].forEach(function (ev) {
      window.addEventListener(ev, function () {
        if (!scrolled) { scrolled = true; sSet('lofiPopScrolled', '1'); }
        maybeExpand();
      }, { passive: true, capture: true });
    });
    var wait = Math.max(0, 8000 - (Date.now() - t0));
    setTimeout(maybeExpand, wait + 100);
  }

  /* ------------------------------------------------------------------ */
  /*  10. Newsletter Popup                                               */
  /* ------------------------------------------------------------------ */

  function initNewsletterPopup() {
    // when the announcement bar (periwinkle pop-down) exists it handles the
    // newsletter triggers (incl. the hero frog) — skip the legacy popup.
    if (document.querySelector('[data-announcement-bar]')) { return; }
    var popup = document.querySelector('[data-newsletter-popup]');
    if (!popup) return;

    function showPopup() {
      popup.classList.add('newsletter-popup--active');
      popup.setAttribute('aria-hidden', 'false');
      var input = popup.querySelector('input[type="email"]');
      if (input) input.focus();
    }

    function hidePopup() {
      popup.classList.remove('newsletter-popup--active');
      popup.setAttribute('aria-hidden', 'true');
    }

    // All triggers (frog + announcement bar link)
    document.querySelectorAll('[data-newsletter-trigger]').forEach(function(trigger) {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        showPopup();
      });
    });

    // Close button
    var closeBtn = popup.querySelector('[data-newsletter-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', hidePopup);
    }
  }

  /* ------------------------------------------------------------------ */
  /*  Global: Escape key handler                                         */
  /* ------------------------------------------------------------------ */

  function initEscapeHandler() {
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;

      // Close mobile menu
      var mobileMenu = document.querySelector('.mobile-menu.mobile-menu--active');
      if (mobileMenu) {
        mobileMenu.classList.remove('mobile-menu--active');
        hideOverlay();
        unlockScroll();
        var menuToggle = document.querySelector('[data-mobile-menu-toggle]');
        if (menuToggle) {
          menuToggle.setAttribute('aria-expanded', 'false');
          menuToggle.focus();
        }
        if (removeFocusTrap) {
          removeFocusTrap();
          removeFocusTrap = null;
        }
        return;
      }

      // Close cart drawer
      var cartDrawer = document.querySelector('.cart-drawer.cart-drawer--active');
      if (cartDrawer) {
        closeCartDrawer();
        return;
      }

      // Close search overlay
      var searchOverlay = document.querySelector('.search-overlay.search-overlay--active');
      if (searchOverlay) {
        searchOverlay.classList.remove('search-overlay--active');
        unlockScroll();
        return;
      }

      // Close newsletter popup
      var newsletterPopup = document.querySelector('.newsletter-popup.newsletter-popup--active');
      if (newsletterPopup) {
        newsletterPopup.classList.remove('newsletter-popup--active');
        newsletterPopup.setAttribute('aria-hidden', 'true');
        return;
      }

      // Close filter panel
      var filterPanel = document.querySelector('.filter-panel--active');
      if (filterPanel) {
        filterPanel.classList.remove('filter-panel--active');
        var fpOverlay = document.querySelector('[data-filter-overlay]');
        if (fpOverlay) fpOverlay.classList.remove('filter-panel__overlay--active');
        var fpToggle = document.querySelector('[data-filter-toggle]');
        if (fpToggle) fpToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /*  11. Hero Slider                                                    */
  /* ------------------------------------------------------------------ */

  function initHeroSlider() {
    var slider = document.querySelector('[data-hero-slider]');
    if (!slider) return;

    var slides = slider.querySelectorAll('[data-hero-slide]');
    var dots = slider.querySelectorAll('[data-hero-dot]');
    var topbars = slider.querySelectorAll('[data-hero-topbar]');
    var nextBtn = slider.querySelector('[data-hero-next]');
    var currentIndex = 0;
    var interval;

    function goToSlide(index) {
      slides.forEach(function(s, i) {
        s.classList.toggle('hero-split__slide--active', i === index);
      });
      dots.forEach(function(d, i) {
        d.classList.toggle('hero-split__dot--active', i === index);
      });
      topbars.forEach(function(t, i) {
        t.classList.toggle('hero-split__topbar-labels--active', i === index);
      });
      currentIndex = index;
    }

    function nextSlide() {
      goToSlide((currentIndex + 1) % slides.length);
    }

    function startAutoplay() {
      interval = setInterval(nextSlide, 5000);
    }

    function stopAutoplay() {
      clearInterval(interval);
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        stopAutoplay();
        nextSlide();
        startAutoplay();
      });
    }

    dots.forEach(function(dot, i) {
      dot.addEventListener('click', function() {
        stopAutoplay();
        goToSlide(i);
        startAutoplay();
      });
    });

    // touch swipe: left = next, right = previous
    var tsx = 0, tsy = 0, swiping = false;
    slider.addEventListener('touchstart', function(e) {
      if (e.touches.length !== 1) return;
      tsx = e.touches[0].clientX; tsy = e.touches[0].clientY; swiping = false;
    }, { passive: true });
    slider.addEventListener('touchmove', function(e) {
      if (e.touches.length !== 1) return;
      var dx = e.touches[0].clientX - tsx, dy = e.touches[0].clientY - tsy;
      if (Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) swiping = true;
    }, { passive: true });
    slider.addEventListener('touchend', function(e) {
      var t = e.changedTouches[0];
      if (!t) return;
      var dx = t.clientX - tsx, dy = t.clientY - tsy;
      if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy)) return;
      stopAutoplay();
      goToSlide((currentIndex + (dx < 0 ? 1 : -1) + slides.length) % slides.length);
      startAutoplay();
    }, { passive: true });
    // stop the click that follows a swipe from navigating the overlaid slide link
    slider.addEventListener('click', function(e) {
      if (swiping) { e.preventDefault(); e.stopPropagation(); swiping = false; }
    }, true);

    // trackpad: a horizontal two-finger scroll flicks through slides. The
    // slides are discrete (no scroll container), so accumulate deltas into
    // one advance per gesture; preventDefault also stops the macOS
    // back/forward history swipe while over the carousel.
    var wheelAcc = 0, wheelLast = 0, wheelLock = 0;
    slider.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) { return; } // vertical = page scroll
      e.preventDefault();
      var now = Date.now();
      if (now - wheelLast > 200) { wheelAcc = 0; } // gap = new gesture
      wheelLast = now;
      if (now < wheelLock) { return; } // this gesture already advanced
      wheelAcc += e.deltaX;
      if (Math.abs(wheelAcc) < 60) { return; }
      stopAutoplay();
      goToSlide((currentIndex + (wheelAcc > 0 ? 1 : -1) + slides.length) % slides.length);
      startAutoplay();
      wheelAcc = 0;
      wheelLock = now + 600;
    }, { passive: false });

    // independent carousel — cycles on its own (unless a static video/gif shows)
    if (slides.length > 1 && !slider.hasAttribute('data-hero-static')) {
      startAutoplay();
    }
  }

  /* ------------------------------------------------------------------ */
  /*  Collection tiles: hover cycles the collection's newest products    */
  /* ------------------------------------------------------------------ */

  function initCollectionTileCycle() {
    if (!window.matchMedia('(hover: hover)').matches) { return; }
    document.querySelectorAll('[data-tile-cycle]').forEach(function (link) {
      var urls = [];
      try { urls = JSON.parse(link.getAttribute('data-tile-cycle')); } catch (e) { return; }
      if (!urls.length) { return; }
      var overlay = null;
      var timer = null;
      var idx = 0;
      function ensureOverlay() {
        if (overlay) { return; }
        // images fetch on first hover only — not on page load
        urls.forEach(function (u) { var im = new Image(); im.src = u; });
        overlay = document.createElement('img');
        overlay.className = 'collection-images__cycle';
        overlay.alt = '';
        overlay.setAttribute('aria-hidden', 'true');
        link.appendChild(overlay);
      }
      var hovering = false;
      link.addEventListener('mouseenter', function () {
        ensureOverlay();
        hovering = true;
        idx = 0;
        overlay.src = urls[0];
        clearInterval(timer);
        // the tile photo stays until the first product shot has actually
        // loaded — no white flash while it downloads
        var start = function () {
          if (!hovering) { return; }
          overlay.classList.add('collection-images__cycle--on');
          timer = setInterval(function () {
            idx = (idx + 1) % urls.length;
            overlay.src = urls[idx];
          }, 450);
        };
        if (overlay.complete && overlay.naturalWidth > 0) {
          start();
        } else {
          overlay.onload = function () { overlay.onload = null; start(); };
        }
      });
      link.addEventListener('mouseleave', function () {
        hovering = false;
        clearInterval(timer);
        timer = null;
        if (overlay) {
          overlay.onload = null;
          overlay.classList.remove('collection-images__cycle--on');
        }
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /*  12. Ranges Expand                                                  */
  /* ------------------------------------------------------------------ */

  function initRangesExpand() {
    var items = document.querySelectorAll('[data-ranges-item]');
    if (!items.length) return;

    // the left slider is an INDEPENDENT carousel (see initHeroSlider); this
    // accordion only manages itself — and one item is ALWAYS expanded.
    var currentOpen = null;
    var autoplayInterval = null;
    var resumeTimer = null;
    var currentIndex = 0;
    var paused = false;

    function openItem(item) {
      if (currentOpen === item) { return; }
      if (currentOpen) {
        currentOpen.classList.remove('hero-split__range-item--active');
      }
      item.classList.add('hero-split__range-item--active');
      currentOpen = item;
    }

    // Autoplay: cycle through items
    function autoplayNext() {
      openItem(items[currentIndex]);
      currentIndex = (currentIndex + 1) % items.length;
    }

    function startAutoplay() {
      paused = false;
      if (autoplayInterval) clearInterval(autoplayInterval);
      autoplayNext();
      autoplayInterval = setInterval(autoplayNext, 6000);
    }

    function stopAutoplay() {
      paused = true;
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
      }
    }

    function pauseAndResume() {
      stopAutoplay();
      if (resumeTimer) clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function() {
        // Resume from the item after the currently open one
        items.forEach(function(el, i) {
          if (el === currentOpen) currentIndex = (i + 1) % items.length;
        });
        startAutoplay();
      }, 10000);
    }

    // Click to toggle — pauses autoplay
    document.addEventListener('click', function(e) {
      var row = e.target.closest('[data-ranges-expand]');
      if (!row) return;
      var item = row.closest('[data-ranges-item]');
      if (!item) return;

      if (!item.classList.contains('hero-split__range-item--active')) {
        // touch: the first tap on a collapsed row EXPANDS it, even on the
        // thumbnail link — navigation stays on the expanded tile's links
        if (!window.matchMedia('(hover: hover)').matches && e.target.closest('a')) {
          e.preventDefault();
        }
        openItem(item);
      }
      pauseAndResume(); // one item stays expanded at all times
    });

    // Hover on desktop — opens immediately and pauses autoplay. (An earlier
    // 110ms hover-intent debounce guarded a hero-image sync that no longer
    // exists — the accordion is independent of the hero now, so instant is
    // safe; the item stays open on mouseleave — one range is always expanded.)
    if (window.matchMedia('(hover: hover)').matches) {
      items.forEach(function(item) {
        item.addEventListener('mouseenter', function() {
          openItem(item);
          pauseAndResume();
        });
      });
    }

    // Start autoplay
    startAutoplay();
  }

  /* ------------------------------------------------------------------ */
  /*  13. Brands Page                                                    */
  /* ------------------------------------------------------------------ */

  function initBrandsPage() {
    var page = document.querySelector('.brands-page');
    if (!page) return;

    // View toggle (LIST / LOGO)
    var viewBtns = page.querySelectorAll('[data-brands-view-toggle]');
    var logoView = page.querySelector('[data-brands-logo-view]');
    var listView = page.querySelector('[data-brands-list-view]');

    viewBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var view = btn.getAttribute('data-brands-view-toggle');
        viewBtns.forEach(function(b) { b.classList.remove('brands-page__view-btn--active'); });
        btn.classList.add('brands-page__view-btn--active');

        if (view === 'logo') {
          logoView.style.display = '';
          listView.style.display = 'none';
        } else {
          logoView.style.display = 'none';
          listView.style.display = '';
        }
      });
    });

    // Alphabet group tabs (ALL, A→I, J→R, S→Z)
    var groupTabs = page.querySelectorAll('[data-brands-group]');
    var allItems = page.querySelectorAll('[data-brand-letter]');
    var letterGroups = page.querySelectorAll('[data-brand-letter-group]');

    groupTabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        groupTabs.forEach(function(t) { t.classList.remove('brands-page__group-tab--active'); });
        tab.classList.add('brands-page__group-tab--active');

        var group = tab.getAttribute('data-brands-group');

        if (group === 'all') {
          // Show all
          allItems.forEach(function(item) { item.style.display = ''; });
          letterGroups.forEach(function(g) { g.style.display = ''; });
        } else {
          var range = group.split('-'); // e.g., "a-i"
          var start = range[0].toUpperCase().charCodeAt(0);
          var end = range[1].toUpperCase().charCodeAt(0);

          allItems.forEach(function(item) {
            var letter = item.getAttribute('data-brand-letter').toUpperCase().charCodeAt(0);
            item.style.display = (letter >= start && letter <= end) ? '' : 'none';
          });

          letterGroups.forEach(function(g) {
            var letter = g.getAttribute('data-brand-letter-group').toUpperCase().charCodeAt(0);
            g.style.display = (letter >= start && letter <= end) ? '' : 'none';
          });
        }
      });
    });

    // Alphabet letter quick-scroll
    var alphaLinks = page.querySelectorAll('[data-brands-alpha]');
    alphaLinks.forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        var letter = link.getAttribute('data-brands-alpha');
        var target = page.querySelector('[data-brand-letter-group="' + letter + '"]');
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /*  14. Ranges Page                                                    */
  /* ------------------------------------------------------------------ */

  function initRangesPage() {
    var page = document.querySelector('.ranges-page');
    if (!page) return;

    var viewBtns = page.querySelectorAll('[data-ranges-view-toggle]');
    var postView = page.querySelector('[data-ranges-post-view]');
    var listView = page.querySelector('[data-ranges-list-view]');

    viewBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var view = btn.getAttribute('data-ranges-view-toggle');
        viewBtns.forEach(function(b) { b.classList.remove('ranges-page__view-btn--active'); });
        btn.classList.add('ranges-page__view-btn--active');

        if (view === 'post') {
          postView.style.display = '';
          listView.style.display = 'none';
        } else {
          postView.style.display = 'none';
          listView.style.display = '';
        }
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /*  15. Lookbook Gallery                                               */
  /* ------------------------------------------------------------------ */

  function initLookbookGallery() {
    var gallery = document.querySelector('[data-lookbook-gallery]');
    if (!gallery) return;

    var images = gallery.querySelectorAll('[data-lookbook-image]');
    var counter = gallery.querySelector('[data-lookbook-counter]');
    var prevBtn = gallery.querySelector('[data-lookbook-prev]');
    var nextBtn = gallery.querySelector('[data-lookbook-next]');
    var currentIndex = 0;

    function showImage(index) {
      images.forEach(function(img, i) {
        img.classList.toggle('lookbook-page__image--active', i === index);
      });
      currentIndex = index;
      if (counter) counter.textContent = (index + 1) + '/' + images.length;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        showImage(currentIndex > 0 ? currentIndex - 1 : images.length - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        showImage((currentIndex + 1) % images.length);
      });
    }
  }

  /* ------------------------------------------------------------------ */
  /*  16. Preview Carousel                                               */
  /* ------------------------------------------------------------------ */

  function initPreviewCarousel() {
    var carousel = document.querySelector('[data-preview-carousel]');
    if (!carousel) return;

    var items = carousel.querySelectorAll('[data-preview-item]');
    var prevBtn = carousel.querySelector('[data-preview-prev]');
    var nextBtn = carousel.querySelector('[data-preview-next]');
    var currentIndex = 0;

    function showItem(index) {
      items.forEach(function(item, i) {
        item.style.display = i === index ? '' : 'none';
      });
      currentIndex = index;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        showItem(currentIndex > 0 ? currentIndex - 1 : items.length - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        showItem((currentIndex + 1) % items.length);
      });
    }

    if (items.length > 0) showItem(0);
  }

  /* ------------------------------------------------------------------ */
  /*  Init                                                               */
  /* ------------------------------------------------------------------ */

  /*  Cart shipping estimate — Country + Postcode → live Shopify rates       */
  function initCartShipping() {
    function defaultCountry() {
      var c = document.querySelector('[data-shipping-country]');
      if (c && !c.dataset.touched && c.value !== 'Australia') {
        var hasAU = Array.prototype.some.call(c.options, function (o) { return o.value === 'Australia'; });
        if (hasAU) { c.value = 'Australia'; }
      }
    }

    // the free-shipping progress bar is an AUSTRALIA-only promise — hide it as
    // soon as the shipper estimates for a different country (re-shown on AU)
    function updateShippingBar() {
      var bar = document.querySelector('.cart-drawer__shipping-bar');
      var country = document.querySelector('[data-shipping-country]');
      if (!bar) { return; }
      var intl = country && country.value && country.value !== 'Australia';
      bar.style.display = intl ? 'none' : '';
    }

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.matches) { return; }
      if (t.matches('[data-shipping-country]')) { t.dataset.touched = '1'; }
      if (t.matches('[data-shipping-country]')) { syncProvinces(); }
      if (t.matches('[data-shipping-country], [data-shipping-zip], [data-shipping-province]')) { estimate(); updateShippingBar(); }
    });

    var drawer = document.querySelector('[data-cart-drawer]');
    if (drawer && window.MutationObserver) {
      // cart re-renders rebuild the bar — re-apply the country gate too
      new MutationObserver(function () { defaultCountry(); updateShippingBar(); }).observe(drawer, { childList: true, subtree: true });
    }
    defaultCountry();
    updateShippingBar();

    // Some countries (Japan/US/Canada...) REQUIRE a province or the rates API
    // rejects ({"province":["Select a prefecture"]}); most don't. There's no
    // flag in the data, so the select stays HIDDEN until the API demands it —
    // countries that don't need it keep the compact country+postcode pair.
    var provinceRequired = {}; // country name -> true once the API said so
    function syncProvinces() {
      var country = document.querySelector('[data-shipping-country]');
      var prov = document.querySelector('[data-shipping-province]');
      if (!country || !prov) { return; }
      var opt = country.options[country.selectedIndex];
      var provinces = [];
      try { provinces = JSON.parse(opt.getAttribute('data-provinces') || '[]'); } catch (e) {}
      prov.innerHTML = '';
      provinces.forEach(function (pair) {
        var o = document.createElement('option');
        o.value = pair[0];
        o.textContent = pair[1];
        prov.appendChild(o);
      });
      prov.hidden = !(provinceRequired[country.value] && provinces.length);
    }
    function revealProvinces() {
      var country = document.querySelector('[data-shipping-country]');
      var prov = document.querySelector('[data-shipping-province]');
      if (!country || !prov || !prov.options.length) { return false; }
      provinceRequired[country.value] = true;
      if (prov.hidden) { prov.hidden = false; return true; }
      return false;
    }

    function estimate() {
      var country = document.querySelector('[data-shipping-country]');
      var zip = document.querySelector('[data-shipping-zip]');
      var prov = document.querySelector('[data-shipping-province]');
      var out = document.querySelector('[data-cart-shipping]');
      if (!country || !out || !country.value) { return; }
      out.textContent = 'Calculating…';
      var addr = 'shipping_address[country]=' + encodeURIComponent(country.value) +
                 '&shipping_address[zip]=' + encodeURIComponent(zip ? zip.value : '');
      if (prov && !prov.hidden && prov.value) {
        addr += '&shipping_address[province]=' + encodeURIComponent(prov.value);
      }
      run(addr, out, 0);
    }
    syncProvinces();

    function run(addr, out, attempt) {
      fetch('/cart/prepare_shipping_rates.json?' + addr, { method: 'POST' })
        .then(function (r) { return r.json().catch(function () { return null; }); })
        .then(function (body) {
          if (body && body.province) {
            // this country needs a state/prefecture — reveal the select and
            // rerun with its (defaulted) value
            if (revealProvinces()) { estimate(); return null; }
            throw new Error('province required');
          }
          return poll(addr, 0);
        })
        .then(function (data) { if (data === null) { return { skip: true }; } return data; })
        .then(function (data) {
          if (data && data.skip) { return; }
          var rates = data && data.shipping_rates;
          if (rates && rates.length) {
            var cheapest = rates.reduce(function (a, b) {
              return parseFloat(a.price) <= parseFloat(b.price) ? a : b;
            });
            var cents = Math.round(parseFloat(cheapest.price) * 100);
            out.innerHTML = cents === 0 ? 'Free' : formatMoney(cents);
            updateTotal(cents);
            return;
          }
          if (attempt < 2) { setTimeout(function () { run(addr, out, attempt + 1); }, 800); }
          else { out.textContent = 'Calculated at checkout'; }
        })
        .catch(function () {
          if (attempt < 2) { setTimeout(function () { run(addr, out, attempt + 1); }, 800); }
          else { out.textContent = 'Calculated at checkout'; }
        });
    }

    function poll(addr, n) {
      return fetch('/cart/async_shipping_rates.json?' + addr)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data && data.shipping_rates === null && n < 12) {
            return new Promise(function (res) {
              setTimeout(function () { res(poll(addr, n + 1)); }, 600);
            });
          }
          return data;
        });
    }

    function updateTotal(shippingCents) {
      var totalOut = document.querySelector('[data-cart-total]');
      if (!totalOut) { return; }
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        totalOut.innerHTML = formatMoney(cart.total_price + shippingCents);
      }).catch(function () {});
    }
  }

  /*  Newsletter pop-down — expand the periwinkle bar into an email form        */
  function initNewsletterPopdown() {
    var bar = document.querySelector('[data-announcement-bar]');
    if (!bar) { return; }
    var toggle = bar.querySelector('[data-popdown-toggle]');
    function openBar() {
      bar.classList.add('announcement-bar--expanded');
      if (toggle) { toggle.setAttribute('aria-expanded', 'true'); }
      var input = bar.querySelector('.announcement-bar__email');
      if (input) { input.focus({ preventScroll: true }); }
    }
    if (toggle) {
      toggle.addEventListener('click', function () {
        var expanded = bar.classList.toggle('announcement-bar--expanded');
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        if (expanded) {
          var input = bar.querySelector('.announcement-bar__email');
          if (input) { input.focus(); }
        }
      });
    }
    // the hero frog (and any other newsletter trigger) opens this same pop-down
    document.querySelectorAll('[data-newsletter-trigger]').forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
        openBar();
      });
    });
    // keep open if the form just posted (shows success/error)
    if (bar.querySelector('.announcement-bar__form-message')) {
      bar.classList.add('announcement-bar--expanded');
      if (toggle) { toggle.setAttribute('aria-expanded', 'true'); }
    }
  }

  // Remember scroll position per-URL and restore it on back/forward navigation,
  // so going Back from a product resumes the collection where you left off.
  function initScrollRestore() {
    if (!('sessionStorage' in window)) return;
    try { history.scrollRestoration = 'manual'; } catch (e) {}
    var PREFIX = 'lofi:scroll:';
    function key() { return PREFIX + location.pathname + location.search; }
    // body has overflow:clip so the scroller can be body OR documentElement — cover both
    function getY() {
      return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    }
    function setY(y) {
      window.scrollTo(0, y);
      if (document.documentElement) document.documentElement.scrollTop = y;
      if (document.body) document.body.scrollTop = y;
    }
    function save() {
      try { sessionStorage.setItem(key(), String(getY())); } catch (e) {}
    }
    // pagehide keeps bfcache alive (unlike beforeunload); the click is a fallback that
    // fires before a product-card link navigates away
    window.addEventListener('pagehide', save);
    document.addEventListener('click', function (e) {
      if (e.target.closest('a[href]')) save();
    }, true);

    function restore() {
      var raw;
      try { raw = sessionStorage.getItem(key()); } catch (e) { return; }
      if (raw == null) return;
      var y = parseInt(raw, 10);
      if (isNaN(y) || y <= 0) return;
      var cancelled = false;
      function cancel() { cancelled = true; }
      window.addEventListener('wheel', cancel, { passive: true, once: true });
      window.addEventListener('touchstart', cancel, { passive: true, once: true });
      window.addEventListener('keydown', cancel, { once: true });
      var deadline = Date.now() + 1500; // keep nudging while lazy content grows the page
      (function tick() {
        if (cancelled) return;
        setY(y);
        if (getY() < y - 2 && Date.now() < deadline) requestAnimationFrame(tick);
      })();
    }

    window.addEventListener('pageshow', function (e) {
      if (e.persisted) { restore(); return; } // restored from bfcache
      var nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || null;
      var isBack = nav ? nav.type === 'back_forward'
        : (performance.navigation && performance.navigation.type === 2);
      if (isBack) restore();
    });
  }

  // Idle screensaver: after inactivity the Lo-Fi logo fills the screen and
  // bounces DVD-style (colour cycles on each edge hit). Any activity dismisses it.
  function initScreensaver() {
    var ss = document.querySelector('[data-screensaver]');
    if (!ss) return;
    var logo = ss.querySelector('[data-screensaver-logo]');
    var asciiEl = ss.querySelector('[data-ascii-logo]');
    var IDLE = parseInt(ss.getAttribute('data-idle'), 10) || 60000;
    var idleTimer, blackoutTimer, raf, x = 0, y = 0, vx = 0, vy = 0, active = false, srcLogo = null;
    var insL = 0, insR = 0, insT = 0, insB = 0, measTick = 0; // blank margins inside the logo box (px)

    // The header logo currently on screen (desktop overlay or mobile), so the
    // screensaver can start bouncing from its exact size + position.
    function visibleHeaderLogo() {
      var els = document.querySelectorAll('.ascii-logo-overlay .ascii-logo, .site-header__mobile-logo .ascii-logo');
      for (var i = 0; i < els.length; i++) {
        var r = els[i].getBoundingClientRect();
        if (r.width > 2 && r.height > 2 && getComputedStyle(els[i]).visibility !== 'hidden') return els[i];
      }
      return null;
    }

    // Measure the visible glyphs' blank margins inside the box (the STL model + spin
    // leave big empty space), so the bounce can put the actual logo against the edges.
    function measureInset() {
      var cv = asciiEl && asciiEl.querySelector('canvas');
      if (!cv || !cv.width || !cv.height) return;
      try {
        var d = cv.getContext('2d').getImageData(0, 0, cv.width, cv.height).data;
        var minX = cv.width, maxX = -1, minY = cv.height, maxY = -1;
        for (var yy = 0; yy < cv.height; yy += 2) {
          var off = yy * cv.width;
          for (var xx = 0; xx < cv.width; xx++) {
            if (d[(off + xx) * 4 + 3] > 24) {
              if (xx < minX) minX = xx; if (xx > maxX) maxX = xx;
              if (yy < minY) minY = yy; if (yy > maxY) maxY = yy;
            }
          }
        }
        if (maxX < 0) return;
        var sx = logo.offsetWidth / cv.width, sy = logo.offsetHeight / cv.height;
        insL = minX * sx; insR = (cv.width - 1 - maxX) * sx;
        insT = minY * sy; insB = (cv.height - 1 - maxY) * sy;
      } catch (e) {}
    }
    function step() {
      var w = logo.offsetWidth, h = logo.offsetHeight;
      var vw = window.innerWidth, vh = window.innerHeight;
      if ((measTick++ & 3) === 0) { measureInset(); } // refresh margins every 4th frame
      // bounce so the visible glyphs (not the empty box) hit the viewport edges
      var xMin = -insL, xMax = vw - w + insR;
      var yMin = -insT, yMax = vh - h + insB;
      x += vx; y += vy;
      if (x <= xMin) { x = xMin; vx = Math.abs(vx); }
      else if (x >= xMax) { x = xMax; vx = -Math.abs(vx); }
      if (y <= yMin) { y = yMin; vy = Math.abs(vy); }
      else if (y >= yMax) { y = yMax; vy = -Math.abs(vy); }
      logo.style.transform = 'translate(' + Math.round(x) + 'px,' + Math.round(y) + 'px)';
      raf = requestAnimationFrame(step);
    }
    var origFill = null, curMode = 'bounce';
    function resizeLogo(fill) {
      var inst = asciiEl && asciiEl.__asciiLogo;
      if (!inst) { return; }
      if (origFill === null) { origFill = (typeof inst.fill === 'number') ? inst.fill : 0.46; }
      // fill = how much of the box the wordmark fills (bigger = less empty margin)
      inst.fill = (fill != null) ? fill : origFill;
      if (typeof inst._resize === 'function') { inst._resize(); }
    }
    // Variation A — DVD bounce: lift off at the header's size/position, bounce edge to edge.
    function startBounce() {
      curMode = 'bounce';
      var r = srcLogo ? srcLogo.getBoundingClientRect() : null;
      logo.style.transition = '';
      logo.style.left = '0px';
      logo.style.top = '0px';
      if (r) {
        logo.style.width = r.width + 'px';
        logo.style.height = r.height + 'px';
        x = r.left; y = r.top;
      } else {
        logo.style.width = '40vmin';
        logo.style.height = '';
        x = window.innerWidth / 2; y = window.innerHeight / 2;
      }
      resizeLogo();
      var speed = 2.4;
      vx = speed * (Math.random() < 0.5 ? -1 : 1);
      vy = speed * (Math.random() < 0.5 ? -1 : 1);
      logo.style.transform = 'translate(' + Math.round(x) + 'px,' + Math.round(y) + 'px)';
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(step);
    }
    // Variation B — zoom: grow from the header up to fill the whole page (centred).
    function startZoom() {
      curMode = 'zoom';
      cancelAnimationFrame(raf); // no bounce in this mode
      var r = srcLogo ? srcLogo.getBoundingClientRect() : null;
      var vw = window.innerWidth, vh = window.innerHeight;
      var aspect = r ? (r.width / r.height) : (360 / 167);
      var fullW = vw, fullH = vw / aspect;
      if (fullH > vh) { fullH = vh; fullW = vh * aspect; }
      var fullL = (vw - fullW) / 2, fullT = (vh - fullH) / 2;
      logo.style.transition = '';
      logo.style.transform = 'none';
      // render crisp at FULL size first (canvas bitmap = full res) ...
      logo.style.width = fullW + 'px'; logo.style.height = fullH + 'px';
      logo.style.left = fullL + 'px'; logo.style.top = fullT + 'px';
      resizeLogo(0.6); // bigger wordmark — fills much more of the page
      // ... then jump to the header box (the full-res canvas just downscales → stays crisp)
      if (r) {
        logo.style.width = r.width + 'px'; logo.style.height = r.height + 'px';
        logo.style.left = r.left + 'px'; logo.style.top = r.top + 'px';
      }
      void logo.offsetWidth; // reflow so the next change animates
      logo.style.transition = 'width 0.8s ease, height 0.8s ease, left 0.8s ease, top 0.8s ease';
      logo.style.width = fullW + 'px'; logo.style.height = fullH + 'px';
      logo.style.left = fullL + 'px'; logo.style.top = fullT + 'px';
    }
    // Variation C — pulse: a big centred logo that breathes in and out.
    function startPulse() {
      curMode = 'pulse';
      cancelAnimationFrame(raf);
      var r = srcLogo ? srcLogo.getBoundingClientRect() : null;
      var vw = window.innerWidth, vh = window.innerHeight;
      var aspect = r ? (r.width / r.height) : (360 / 167);
      var w = Math.min(vw, vh * aspect) * 0.8;
      var h = w / aspect;
      logo.style.transition = '';
      logo.style.animation = '';
      logo.style.transform = 'none';
      logo.style.width = w + 'px'; logo.style.height = h + 'px';
      logo.style.left = ((vw - w) / 2) + 'px'; logo.style.top = ((vh - h) / 2) + 'px';
      resizeLogo(0.6);
      logo.style.animation = 'screensaver-pulse 2.6s ease-in-out infinite';
    }
    // Variation D — orbit: the logo cruises a slow ellipse around the screen centre,
    // easing onto the path from wherever the header logo sits.
    function startOrbit() {
      curMode = 'orbit';
      cancelAnimationFrame(raf);
      var r = srcLogo ? srcLogo.getBoundingClientRect() : null;
      var vw = window.innerWidth, vh = window.innerHeight;
      var aspect = r ? (r.width / r.height) : (360 / 167);
      var w = Math.min(vw, vh * aspect) * 0.5, h = w / aspect;
      logo.style.transition = '';
      logo.style.left = '0px'; logo.style.top = '0px';
      // render crisp at travel size first (same trick as zoom), then grow from the header box
      logo.style.width = w + 'px'; logo.style.height = h + 'px';
      resizeLogo(0.6);
      if (r) {
        logo.style.width = r.width + 'px'; logo.style.height = r.height + 'px';
        x = r.left; y = r.top;
      } else { x = (vw - w) / 2; y = (vh - h) / 2; }
      logo.style.transform = 'translate(' + Math.round(x) + 'px,' + Math.round(y) + 'px)';
      void logo.offsetWidth;
      logo.style.transition = 'width 0.8s ease, height 0.8s ease';
      logo.style.width = w + 'px'; logo.style.height = h + 'px';
      var cx = (vw - w) / 2, cy = (vh - h) / 2;
      var rx = (vw - w) * 0.42, ry = (vh - h) * 0.42, t = -Math.PI / 2;
      (function orbitStep() {
        t += 0.008;
        var tx = cx + Math.cos(t) * rx, ty = cy + Math.sin(t) * ry;
        x += (tx - x) * 0.04; y += (ty - y) * 0.04; // ease onto the ellipse
        logo.style.transform = 'translate(' + Math.round(x) + 'px,' + Math.round(y) + 'px)';
        raf = requestAnimationFrame(orbitStep);
      })();
    }
    // Variation E — wander: drifts lazily to random spots around the page.
    function startWander() {
      curMode = 'wander';
      cancelAnimationFrame(raf);
      var r = srcLogo ? srcLogo.getBoundingClientRect() : null;
      var vw = window.innerWidth, vh = window.innerHeight;
      var aspect = r ? (r.width / r.height) : (360 / 167);
      var w = Math.min(vw, vh * aspect) * 0.55, h = w / aspect;
      logo.style.transition = '';
      logo.style.left = '0px'; logo.style.top = '0px';
      logo.style.width = w + 'px'; logo.style.height = h + 'px';
      resizeLogo(0.6);
      if (r) {
        logo.style.width = r.width + 'px'; logo.style.height = r.height + 'px';
        x = r.left; y = r.top;
      } else { x = (vw - w) / 2; y = (vh - h) / 2; }
      logo.style.transform = 'translate(' + Math.round(x) + 'px,' + Math.round(y) + 'px)';
      void logo.offsetWidth;
      logo.style.transition = 'width 0.8s ease, height 0.8s ease';
      logo.style.width = w + 'px'; logo.style.height = h + 'px';
      var tx, ty;
      function pickSpot() {
        tx = Math.random() * (vw - w);
        ty = Math.random() * (vh - h);
      }
      pickSpot();
      (function wanderStep() {
        x += (tx - x) * 0.02; y += (ty - y) * 0.02;
        if (Math.abs(tx - x) < 8 && Math.abs(ty - y) < 8) { pickSpot(); }
        logo.style.transform = 'translate(' + Math.round(x) + 'px,' + Math.round(y) + 'px)';
        raf = requestAnimationFrame(wanderStep);
      })();
    }
    // Drag pop-out: after a long drag on the header logo it detaches and follows
    // the pointer; on release it zooms back to its original spot.
    var dragW = 0, dragH = 0;
    function popOut(px, py) {
      if (active || window.matchMedia('(max-width: 749px)').matches) { return; } // no screensaver on mobile
      if (document.documentElement.classList.contains('logo-intro')) { return; } // original logo showing — nothing to pop out
      active = true;
      curMode = 'drag';
      ss.classList.add('screensaver--active');
      ss.classList.add('screensaver--drag'); // blend so the white logo stays visible while dragged
      ss.setAttribute('aria-hidden', 'false');
      srcLogo = visibleHeaderLogo();
      var r = srcLogo ? srcLogo.getBoundingClientRect() : null;
      if (srcLogo) { srcLogo.style.visibility = 'hidden'; }
      cancelAnimationFrame(raf);
      logo.style.transition = '';
      logo.style.animation = '';
      logo.style.left = '0px'; logo.style.top = '0px';
      if (r) { logo.style.width = r.width + 'px'; logo.style.height = r.height + 'px'; }
      else { logo.style.width = '40vmin'; logo.style.height = ''; }
      var inst = asciiEl && asciiEl.__asciiLogo;
      if (inst) { inst.spinMode = 'rock'; } // match the header logo's spin/size exactly
      resizeLogo();
      dragW = logo.offsetWidth; dragH = logo.offsetHeight;
      popMove(px, py);
    }
    function popMove(px, py) {
      if (curMode !== 'drag') { return; }
      logo.style.transform = 'translate(' + Math.round(px - dragW / 2) + 'px,' + Math.round(py - dragH / 2) + 'px)';
    }
    function popEnd() {
      if (curMode === 'drag') { deactivate(); } // zooms back to its spot
    }
    function activate(mode) {
      if (active || window.matchMedia('(max-width: 749px)').matches) return; // no screensaver on mobile
      active = true;
      ss.classList.add('screensaver--active');
      ss.setAttribute('aria-hidden', 'false');
      srcLogo = visibleHeaderLogo();
      if (srcLogo) { srcLogo.style.visibility = 'hidden'; }
      var inst0 = asciiEl && asciiEl.__asciiLogo;
      if (inst0) { inst0.spinMode = 'turntable'; } // screensaver variations spin
      // pick a variation each time it kicks in (forceable via the exposed API)
      var modes = ['bounce', 'zoom', 'pulse', 'orbit', 'wander'];
      var m = mode;
      if (modes.indexOf(m) === -1) {
        m = modes[Math.floor(Math.random() * modes.length)];
      }
      if (m === 'zoom') { startZoom(); }
      else if (m === 'pulse') { startPulse(); }
      else if (m === 'orbit') { startOrbit(); }
      else if (m === 'wander') { startWander(); }
      else { startBounce(); }
      // lift off white (visible over the live page), then fade the LOGO to black
      clearTimeout(blackoutTimer);
      blackoutTimer = setTimeout(function () { if (active) ss.classList.add('screensaver--blackout'); }, 900);
    }
    function finishDeactivate() {
      ss.classList.remove('screensaver--active');
      ss.classList.remove('screensaver--blackout');
      ss.classList.remove('screensaver--drag');
      ss.classList.remove('screensaver--fading');
      ss.setAttribute('aria-hidden', 'true');
      logo.style.transition = '';
      logo.style.animation = '';
      logo.style.transform = '';
      logo.style.width = ''; logo.style.height = '';
      logo.style.left = ''; logo.style.top = '';
      if (srcLogo) {
        srcLogo.style.visibility = '';
        srcLogo.style.transition = '';
        srcLogo.style.opacity = '';
        srcLogo = null;
      }
      curMode = 'none';
      clearTimeout(idleTimer);
      idleTimer = setTimeout(activate, IDLE); // re-arm the idle screensaver
    }
    function deactivate() {
      if (!active) return;
      active = false;
      clearTimeout(blackoutTimer);
      if (curMode === 'drag') {
        // drag release keeps the zoom-back-to-the-header interaction
        cancelAnimationFrame(raf);
        logo.style.animation = '';
        ss.classList.remove('screensaver--blackout'); // colour eases back as it returns
        var r = srcLogo ? srcLogo.getBoundingClientRect() : null;
        if (r) {
          var called = false;
          var done = function () {
            if (called) { return; }
            called = true;
            logo.removeEventListener('transitionend', done);
            finishDeactivate();
          };
          logo.style.transition = 'transform 0.5s ease';
          logo.style.transform = 'translate(' + Math.round(r.left) + 'px,' + Math.round(r.top) + 'px)';
          logo.addEventListener('transitionend', done);
          setTimeout(done, 650);
        } else {
          finishDeactivate();
        }
        return;
      }
      // Idle-interrupt: fade the saver out right where it is (motion keeps
      // running under the fade) while the header logo fades back in.
      ss.classList.add('screensaver--fading');
      if (srcLogo) {
        srcLogo.style.transition = '';
        srcLogo.style.opacity = '0';
        srcLogo.style.visibility = '';
        void srcLogo.offsetWidth;
        srcLogo.style.transition = 'opacity 1.2s ease';
        srcLogo.style.opacity = '1';
      }
      setTimeout(function () {
        cancelAnimationFrame(raf);
        logo.style.animation = ''; // stop any pulse
        finishDeactivate();
      }, 1250);
    }
    function reset() {
      if (curMode === 'drag') { return; } // drag pop-out ends on release, not on activity
      if (active) deactivate();
      clearTimeout(idleTimer);
      idleTimer = setTimeout(activate, IDLE);
    }
    ['mousemove', 'mousedown', 'keydown', 'touchstart', 'touchmove', 'scroll', 'wheel', 'click'].forEach(function (ev) {
      window.addEventListener(ev, reset, { passive: true });
    });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { deactivate(); clearTimeout(idleTimer); } else { reset(); }
    });
    reset();
    window.theme = window.theme || {};
    window.theme.screensaver = { activate: activate, deactivate: deactivate, popOut: popOut, popMove: popMove, popEnd: popEnd };
  }

  // % OFF badge: randomise the jiggle kick per hover (direction + strength)
  // so it wobbles a little differently every time. Restarts cleanly on fast
  // re-hovers by yanking the animation for a frame.
  function initDiscountJiggle() {
    function kickBadge(badge, force) {
      // the shipping band is a big wide element — a full-strength wobble reads
      // frantic on it, so it gets roughly half the kick of the small % badge
      var calm = badge.classList.contains('shipping-highlight') ? 0.45 : 1;
      var kick = (3 + Math.random() * 5) * calm * (Math.random() < 0.5 ? -1 : 1);
      badge.style.setProperty('--j', kick.toFixed(1) + 'deg');
      badge.style.animation = 'none';
      void badge.offsetWidth;
      // clicks must animate even though :hover is already active — run the
      // animation inline instead of relying on the hover rule
      badge.style.animation = force ? 'price-discount-jiggle 0.18s ease-out' : '';
    }
    document.addEventListener('mouseenter', function (e) {
      var badge = e.target && e.target.closest && e.target.closest('.price__discount, .shipping-highlight');
      if (badge) { kickBadge(badge, false); }
    }, true);
    document.addEventListener('click', function (e) {
      var badge = e.target && e.target.closest && e.target.closest('.price__discount, .shipping-highlight');
      if (badge) { kickBadge(badge, true); }
    });
  }

  // Hold-drag the header logo for ~2s and it pops out to drag freely; release zooms it home.
  function initLogoPopout() {
    var timer = null, dragging = false, px = 0, py = 0;
    function api() { return window.theme && window.theme.screensaver; }
    document.addEventListener('pointerdown', function (e) {
      var hit = e.target.closest && e.target.closest('.ascii-logo-overlay, .site-header__mobile-logo');
      if (!hit) { return; }
      px = e.clientX; py = e.clientY;
      clearTimeout(timer);
      timer = setTimeout(function () {
        var a = api();
        if (a && a.popOut) { dragging = true; a.popOut(px, py); }
      }, 2000);
    }, true);
    document.addEventListener('pointermove', function (e) {
      px = e.clientX; py = e.clientY;
      if (dragging) { var a = api(); if (a && a.popMove) { a.popMove(px, py); } }
    });
    function up() {
      clearTimeout(timer);
      if (dragging) { dragging = false; var a = api(); if (a && a.popEnd) { a.popEnd(); } }
    }
    document.addEventListener('pointerup', up);
    document.addEventListener('pointercancel', up);
  }

  // ASCII loading animations — a grab-bag of little text fireworks. Each
  // cycle the element picks a random variant: boom, firework, implosion,
  // sparkler, rain, pulse. Pure text frames in a <pre>; pauses offscreen.
  function initAsciiBoom() {
    var els = document.querySelectorAll('[data-ascii-boom]');
    if (!els.length) { return; }
    var W = 25, H = 11, CX = 12, CY = 5;
    var RING = ['@', '#', '*', '+', 'x', '\u00b7'];
    function ringChar(r) { return RING[Math.min(RING.length - 1, Math.floor(r / 1.3))]; }

    var VARIANTS = [
      { len: 16, cell: function (x, y, t, d) { // boom (the original)
          if (t < 4) { return d < 0.6 + (t % 2) * 0.5 ? (t % 2 ? '@' : '*') : ' '; }
          var r = (t - 4) * 0.85;
          if (Math.abs(d - r) < 0.75) { return ringChar(r); }
          if (d < r - 0.7 && Math.random() < 0.06) { return Math.random() < 0.5 ? '\u00b7' : '+'; }
          if (t < 7 && d < 1) { return '#'; }
          return ' ';
        } },
      { len: 18, cell: function (x, y, t, d, dx, dy) { // firework: rocket up, starburst
          if (t < 6) {
            var ry = H - 1 - t;
            if (x === CX && y === ry) { return '|'; }
            if (x === CX && y === ry + 1) { return '\u00b7'; }
            return ' ';
          }
          var r = (t - 6) * 0.8;
          var onRay = Math.abs(dx) < 0.4 || Math.abs(dy) < 0.4 || Math.abs(Math.abs(dx) - Math.abs(dy)) < 0.5;
          if (onRay && Math.abs(d - r) < 1 && d <= r) { return ringChar(r); }
          if (d < r && Math.random() < 0.05) { return '\u00b7'; }
          return ' ';
        } },
      { len: 15, cell: function (x, y, t, d) { // implosion: ring collapses, pop
          if (t < 10) {
            var r = 8 - t * 0.8;
            if (Math.abs(d - r) < 0.75) { return RING[RING.length - 1 - Math.min(RING.length - 1, Math.floor(r / 1.6))]; }
            return ' ';
          }
          if (t < 12) { return d < 1.2 ? '@' : ' '; }
          var r2 = (t - 11) * 1.4;
          return Math.abs(d - r2) < 0.8 ? '+' : ' ';
        } },
      { len: 14, cell: function (x, y, t, d) { // sparkler: crackling core
          if (d < 0.8) { return '#'; }
          if (d < 4.2) {
            var p = 0.22 - d * 0.04;
            if (Math.random() < p) { return ['*', '+', 'x', '\u00b7'][Math.floor(Math.random() * 4)]; }
          }
          return ' ';
        } },
      { len: 16, cell: function (x, y, t) { // rain: falling columns
          var drop = (x * 7 + t * 2) % (H + 6);
          if (y === drop) { return '|'; }
          if (y === drop - 1) { return '\u00b7'; }
          if (y === drop - 2 && x % 3 === 0) { return '\u00b7'; }
          return ' ';
        } },
      { len: 16, cell: function (x, y, t, d) { // pulse: breathing rings
          var r = 2.4 + 1.8 * Math.sin(t * 0.55);
          if (Math.abs(d - r) < 0.7) { return '*'; }
          if (Math.abs(d - r * 2) < 0.6) { return '\u00b7'; }
          if (d < 0.7) { return '@'; }
          return ' ';
        } }
    ];

    els.forEach(function (el) {
      if (el.__boom) { return; }
      el.__boom = true;
      var t = 0, timer = null;
      var v = VARIANTS[Math.floor(Math.random() * VARIANTS.length)];
      function frame() {
        var out = [];
        for (var y = 0; y < H; y++) {
          var row = '';
          for (var x = 0; x < W; x++) {
            var dx = (x - CX) / 2, dy = y - CY;
            row += v.cell(x, y, t, Math.sqrt(dx * dx + dy * dy), dx, dy) || ' ';
          }
          out.push(row);
        }
        el.textContent = out.join('\n');
        t++;
        if (t >= v.len) { t = 0; v = VARIANTS[Math.floor(Math.random() * VARIANTS.length)]; }
      }
      function start() { if (!timer) { frame(); timer = setInterval(frame, 90); } }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      if (window.IntersectionObserver) {
        new IntersectionObserver(function (en) {
          if (en[0].isIntersecting && !document.hidden) { start(); } else { stop(); }
        }, { threshold: 0 }).observe(el);
      } else { start(); }
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { stop(); } else if (el.getBoundingClientRect().width) { start(); }
      });
    });
  }
  window.theme = window.theme || {};
  window.theme.initAsciiBoom = initAsciiBoom;

  // Mobile product gallery: swiping past the last photo loops back to the
  // first. A clone of photo 1 sits at the end; once the swipe settles on it
  // we jump (instantly — same frame) to the real first, so it reads as a loop.
  function initGalleryLoop() {
    var gallery = document.querySelector('.main-product__gallery');
    if (!gallery) { return; }
    var cloned = false;
    function ensureClone() {
      if (cloned) { return; }
      // only the horizontal (mobile/tablet) carousel loops — the desktop
      // vertical stack must not get a duplicate photo
      if (gallery.scrollWidth <= gallery.clientWidth + 4) { return; }
      var slides = gallery.querySelectorAll('.main-product__image-wrap');
      if (slides.length < 2) { return; }
      var clone = slides[0].cloneNode(true);
      clone.removeAttribute('id'); // thumbnails keep targeting the real first
      clone.setAttribute('aria-hidden', 'true');
      gallery.appendChild(clone);
      cloned = true;
    }
    ensureClone();
    window.addEventListener('resize', ensureClone);

    var settle = null;
    gallery.addEventListener('scroll', function () {
      if (!cloned) { return; }
      clearTimeout(settle);
      settle = setTimeout(function () {
        // settled on the clone (last cell) → snap to the real first
        if (gallery.scrollLeft >= gallery.scrollWidth - gallery.clientWidth - 4) {
          gallery.style.scrollBehavior = 'auto';
          gallery.scrollLeft = 0;
          gallery.style.scrollBehavior = '';
        }
      }, 90);
    }, { passive: true });
  }

  // Fixed (bounce-proof) footer: the page scrolls over the pinned footer and
  // a spacer at the document end reveals it — keep the spacer's height synced
  // to the footer's rendered height.
  function initFixedFooter() {
    var footer = document.querySelector('.site-footer');
    if (!footer) { return; }
    function size() {
      document.documentElement.style.setProperty('--footer-h', footer.offsetHeight + 'px');
    }
    size();
    window.addEventListener('resize', size);
    if (window.ResizeObserver) { new ResizeObserver(size).observe(footer); }
    window.addEventListener('load', size);
  }

  // Kiwi Sizing: the app's script (store-wide ScriptTag) renders a chart into
  // .sizeChart when this product has one configured. The Sizing tab ships
  // hidden; reveal it only once a chart actually lands, so chartless
  // products never show an empty tab.
  //
  // Butter Goods products additionally check the baked match map
  // (assets/butter-sizing-map.json — Lo-Fi handle -> buttergoods.com product
  // id, built offline by ~/Projects/lofi-sizing-sync with strict matching).
  // For mapped products the buttergoods.com chart is fetched LIVE from
  // Kiwi's public API and rendered in theme markup; it always wins over a
  // local Lo-Fi Kiwi chart. Any failure falls back to the local behavior.
  function initKiwiSizing() {
    var tab = document.querySelector('[data-kiwi-sizing]');
    if (!tab) { return; }

    function watchLocalKiwi() {
      if (tab.querySelector('.ks-chart-container')) { tab.hidden = false; return; }
      var observer = new MutationObserver(function (mutations, me) {
        if (tab.querySelector('.ks-chart-container')) {
          tab.hidden = false;
          me.disconnect();
        }
      });
      observer.observe(tab, { childList: true, subtree: true });
    }

    var mapUrl = tab.getAttribute('data-sizing-map');
    var handle = tab.getAttribute('data-product-handle');
    if (!mapUrl || !handle) { watchLocalKiwi(); return; }

    fetch(mapUrl).then(function (r) { return r.ok ? r.json() : null; })
      .then(function (map) {
        var bgId = map && map.vendor === tab.getAttribute('data-product-vendor') &&
          map.products && map.products[handle];
        if (!bgId) { watchLocalKiwi(); return; }
        // Kiwi's API throws transient 400s under load — retry with backoff,
        // and cache per-product for the session so revisits skip it entirely
        var cacheKey = 'butterSizing:' + bgId;
        var cached = null;
        try { cached = JSON.parse(sessionStorage.getItem(cacheKey)); } catch (e) {}
        function renderable(data) {
          return (data && data.sizings || []).some(function (s) {
            return s.isEnabled !== false && s.tables && s.layout;
          });
        }
        function fetchChart(attempt) {
          return fetch('https://app.kiwisizing.com/api/getSizingChart?shop=' +
              encodeURIComponent(map.shop) + '&product=' + bgId)
            .then(function (r) {
              if (r.ok) { return r.json(); }
              throw new Error('kiwi ' + r.status);
            })
            .then(function (data) {
              // Kiwi serves a freshly-published chart intermittently while its
              // caches warm — an empty response may be transient, so retry a
              // few times before giving up rather than treating empty as final.
              if (!renderable(data) && attempt < 4) {
                return new Promise(function (resolve) {
                  setTimeout(function () { resolve(fetchChart(attempt + 1)); }, 1200 * (attempt + 1));
                });
              }
              return data;
            })
            .catch(function (err) {
              if (attempt >= 4) { throw err; }
              return new Promise(function (resolve) {
                setTimeout(function () { resolve(fetchChart(attempt + 1)); }, 1200 * (attempt + 1));
              });
            });
        }
        return (cached ? Promise.resolve(cached) : fetchChart(0))
          .then(function (data) {
            // Only cache a chart that actually rendered — never cache an empty
            // (cold-window) result, or the tab would stay hidden all session
            // even once Kiwi warms up.
            if (!cached && renderable(data)) {
              try { sessionStorage.setItem(cacheKey, JSON.stringify({ sizings: data.sizings })); } catch (e) {}
            }
            var sizings = (data && data.sizings || []).filter(function (s) {
              return s.isEnabled !== false && s.tables && s.layout;
            });
            if (!sizings.length || !renderButterSizing(tab, sizings)) {
              watchLocalKiwi();
              return;
            }
            tab.classList.add('main-product__collapsible--butter-sizing');
            tab.hidden = false;
          });
      })
      .catch(watchLocalKiwi);
  }

  // Build theme-styled markup from Kiwi chart JSON (tables of
  // {type, value, unitType} cells + a layout listing tables/notes).
  // Returns true if at least one table was rendered.
  function renderButterSizing(tab, sizings) {
    var CM_PER_INCH = 2.54;
    var host = tab.querySelector('.main-product__collapsible-content');
    var wrap = document.createElement('div');
    wrap.className = 'butter-sizing';
    var hasDims = false;

    function cellText(cell, unit) {
      var v = cell.value;
      if (cell.unitType === 'cm' || cell.unitType === 'inches') {
        hasDims = true;
        var n = parseFloat(v);
        if (!isNaN(n)) {
          if (unit === 'in') {
            var inches = cell.unitType === 'inches' ? n : n / CM_PER_INCH;
            return (Math.round(inches * 10) / 10).toString();
          }
          var cm = cell.unitType === 'cm' ? n : n * CM_PER_INCH;
          return (Math.round(cm * 10) / 10).toString();
        }
      }
      return v == null ? '' : String(v);
    }

    function buildTable(rows, unit) {
      var table = document.createElement('table');
      table.className = 'butter-sizing__table';
      rows.forEach(function (row) {
        var tr = document.createElement('tr');
        row.forEach(function (cell) {
          var td = document.createElement(cell.type === 'header' ? 'th' : 'td');
          td.textContent = cellText(cell, unit);
          tr.appendChild(td);
        });
        table.appendChild(tr);
      });
      return table;
    }

    var tableSlots = [];
    var rendered = 0;
    sizings.forEach(function (s) {
      if (sizings.length > 1 && s.name) {
        var h = document.createElement('p');
        h.className = 'butter-sizing__name';
        h.textContent = s.name;
        wrap.appendChild(h);
      }
      ((s.layout && s.layout.data) || []).forEach(function (item) {
        if (item.type === 1 && s.tables && s.tables[item.value] && s.tables[item.value].data) {
          var slot = document.createElement('div');
          slot.className = 'butter-sizing__tablewrap';
          slot.appendChild(buildTable(s.tables[item.value].data, 'cm'));
          wrap.appendChild(slot);
          tableSlots.push({ slot: slot, rows: s.tables[item.value].data });
          rendered++;
        } else if (item.type === 0 && typeof item.value === 'string') {
          // note text authored in Kiwi — strip its inline styling, keep words
          var tmp = document.createElement('div');
          tmp.innerHTML = item.value;
          var text = (tmp.textContent || '').trim();
          if (text) {
            var p = document.createElement('p');
            p.className = 'butter-sizing__note';
            p.textContent = text;
            wrap.appendChild(p);
          }
        } else if (item.type === 6 && item.data && item.data.url) {
          var img = document.createElement('img');
          img.src = item.data.url.indexOf('//') === 0 ? 'https:' + item.data.url : item.data.url;
          img.alt = '';
          img.loading = 'lazy';
          img.className = 'butter-sizing__img';
          wrap.appendChild(img);
        }
      });
    });
    if (!rendered) { return false; }

    if (hasDims) {
      var toggle = document.createElement('div');
      toggle.className = 'butter-sizing__units';
      ['cm', 'in'].forEach(function (unit, i) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.textContent = unit === 'in' ? 'inches' : 'cm';
        btn.className = 'butter-sizing__unit' + (i === 0 ? ' butter-sizing__unit--on' : '');
        btn.addEventListener('click', function () {
          toggle.querySelectorAll('.butter-sizing__unit').forEach(function (b) {
            b.classList.toggle('butter-sizing__unit--on', b === btn);
          });
          tableSlots.forEach(function (t) {
            var fresh = buildTable(t.rows, unit);
            t.slot.replaceChild(fresh, t.slot.firstChild);
          });
        });
        toggle.appendChild(btn);
      });
      wrap.insertBefore(toggle, wrap.firstChild);
    }

    host.appendChild(wrap);
    return true;
  }

  // Character cursor trail in the footer's blue logo box — white L O F I
  // glyphs (bold Cygnito) spawn under the cursor and tumble away. Adapted
  // from tholman/cursor-effects' characterCursor (MIT), scoped to the box:
  // the canvas covers only the blue block, so particles clip at its edges.
  function initFooterCursorEffect() {
    var box = document.querySelector('.site-footer__logo-col');
    if (!box) { return; }
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reduced.matches) { return; }

    var CHARS = ['l', 'o', 'f', 'i'];
    var FONT = 'bold 9px "Suisse Intl", Helvetica, Arial, sans-serif';
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var canvas, ctx, particles = [], sprites = [], raf = null;

    function makeSprites() {
      // rasterize at 2x the display density: particles draw at up to 2x
      // scale when they spawn, so without the headroom they stretch blurry
      var f = dpr * 2;
      sprites = CHARS.map(function (ch) {
        var m = document.createElement('canvas');
        var mc = m.getContext('2d');
        mc.font = FONT;
        var w = Math.ceil(mc.measureText(ch).width) + 4;
        var h = 13;
        m.width = w * f;
        m.height = h * f;
        mc.scale(f, f);
        mc.font = FONT;
        mc.textAlign = 'center';
        mc.textBaseline = 'middle';
        mc.fillStyle = '#fff';
        mc.fillText(ch, w / 2, h / 2);
        m._w = w;
        m._h = h;
        return m;
      });
    }

    function size() {
      canvas.width = box.clientWidth * dpr;
      canvas.height = box.clientHeight * dpr;
      canvas.style.width = box.clientWidth + 'px';
      canvas.style.height = box.clientHeight + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    function Particle(x, y, sprite) {
      this.life = Math.floor(Math.random() * 60 + 80);
      this.initialLife = this.life;
      this.age = 0;
      this.rotSign = Math.random() < 0.5 ? -1 : 1;
      this.x = x;
      this.y = y;
      // gentle drift (library default is *5 — too fast for the small box)
      this.vx = (Math.random() < 0.5 ? -1 : 1) * Math.random() * 1.4;
      this.vy = (Math.random() < 0.5 ? -1 : 1) * Math.random() * 1.4;
      this.sprite = sprite;
    }

    Particle.prototype.update = function () {
      this.x += this.vx;
      this.y += this.vy;
      this.life--;
      this.age++;
      this.vx += (Math.random() < 0.5 ? -1 : 1) / 30;
      this.vy += (Math.random() < 0.5 ? -1 : 1) / 15;
      var scale = Math.max((this.life / this.initialLife) * 2, 0);
      var radians = this.rotSign * (this.life / 5) * 0.0174533;
      ctx.translate(this.x, this.y);
      ctx.rotate(radians);
      ctx.drawImage(
        this.sprite,
        (-this.sprite._w / 2) * scale,
        -this.sprite._h / 2,
        this.sprite._w * scale,
        this.sprite._h * scale
      );
      ctx.rotate(-radians);
      ctx.translate(-this.x, -this.y);
    };

    var spawnIndex = 0;
    function spawn(clientX, clientY) {
      var r = box.getBoundingClientRect();
      particles.push(new Particle(
        clientX - r.left,
        clientY - r.top,
        sprites[spawnIndex++ % sprites.length] // cycle l → o → f → i
      ));
      if (!raf) { raf = requestAnimationFrame(loop); }
    }

    function loop() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      for (var i = 0; i < particles.length; i++) { particles[i].update(); }
      for (var j = particles.length - 1; j >= 0; j--) {
        if (particles[j].life < 0) { particles.splice(j, 1); }
      }
      if (particles.length) {
        raf = requestAnimationFrame(loop);
      } else {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        raf = null;
      }
    }

    function start() {
      canvas = document.createElement('canvas');
      canvas.className = 'site-footer__cursor-fx';
      ctx = canvas.getContext('2d');
      box.appendChild(canvas);
      size();
      makeSprites();
      if (window.ResizeObserver) { new ResizeObserver(size).observe(box); }
      // every 8th move event only — 1/8 of the original reactivity
      var moveTick = 0;
      box.addEventListener('mousemove', function (e) {
        if (moveTick++ % 8) { return; }
        spawn(e.clientX, e.clientY);
      });
      box.addEventListener('touchmove', function (e) {
        for (var i = 0; i < e.touches.length; i++) { spawn(e.touches[i].clientX, e.touches[i].clientY); }
      }, { passive: true });
    }

    // Cygnito must be loaded before the glyph sprites are drawn
    if (document.fonts && document.fonts.load) {
      document.fonts.load(FONT).then(start, start);
    } else {
      start();
    }
  }

  function init() {
    initFixedFooter();
    // heal any pre-existing orphan companions (e.g. grips whose deck is gone)
    fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); })
      .then(reconcileCompanions).catch(function () {});
    initGalleryLoop();
    initAsciiBoom();
    initScrollRestore();
    initScreensaver();
    initLogoPopout();
    initDiscountJiggle();
    initMobileMenu();
    initCartDrawer();
    initSearch();
    initFilters();
    initNavSubrowHold();
    initProductPage();
    initStickyHeader();
    initMarquee();
    initCollectionSort();
    initProductCardHover();
    initCurrencyToggle();
    initNewsletterPop();
    initLogoIntro();
    initHoverImageFit();
    initHoverImageLoad();
    window.theme.hoverImageFit = initHoverImageFit;
    initNewsletterPopup();
    initEscapeHandler();
    initHeroSlider();
    initRangesExpand();
    initCollectionTileCycle();
    initBrandsPage();
    initRangesPage();
    initLookbookGallery();
    initPreviewCarousel();
    initCartShipping();
    initKiwiSizing();
    initSearchInfiniteScroll();
    initFooterCursorEffect();
    initNewsletterPopdown();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose utilities globally for use in Liquid inline scripts if needed
  window.theme = window.theme || {};
  window.theme.formatMoney = formatMoney;
  window.theme.fetchCart = fetchCart;
  window.theme.updateCartDrawer = updateCartDrawer;
  window.theme.debounce = debounce;
})();
